import React, { useEffect, useState, useRef } from 'react'
import { Graph, Markup, Node, Edge } from '@antv/x6';
import { Menu, ContextMenu, Dropdown } from '@antv/x6-react-components'
import qs from 'qs'
import { SocketModule } from '../../modules/socket'
import user_default from '../../static/image/user_default.png'
import noImg from '../../static/image/noImg.png'

import { Transform } from "@antv/x6-plugin-transform";
// less
import { register, Portal } from '@antv/x6-react-shape'
import '@antv/x6-react-components/es/menu/style/index.css'
import style from './index.module.scss'
import { diskMenu, nodeInit, edgeMenu, edgeInit, groupInit, groupNode, graphAddEdge, graphAddNodeMemo, graphAddNodeComment, graphAddGroup, graphAddGroupNode } from './nodeType'
import { Clipboard } from "@antv/x6-plugin-clipboard";
import { Keyboard } from "@antv/x6-plugin-keyboard";
import { MiniMap } from '@antv/x6-plugin-minimap'
import {
    createRoot
} from 'react-dom/client';
import {
    PlusCircleOutlined, CheckOutlined, PlusSquareOutlined, MessageOutlined, NodeIndexOutlined, SwapOutlined,
    EyeOutlined, DashOutlined, EyeInvisibleOutlined, CopyOutlined, LinkOutlined, ContainerOutlined,
    CaretRightOutlined, SmileOutlined, UploadOutlined, EditOutlined, MinusCircleOutlined, CloseCircleOutlined, VerticalAlignTopOutlined
} from '@ant-design/icons';
import { Popconfirm, Modal, Input, Button, Form, DatePicker, message, InputNumber, Image, Checkbox } from 'antd'
import type { DatePickerProps, UploadProps } from 'antd';

import { StorageModule } from '../../modules/storage'
import { createHashHistory } from "history";
import * as apis from '../../api/networkDisk'
import { getUserList } from '../../api/user'
import useStore from '../../store/useStore'
import { deepCopy, getImgUrlById, getCharCount, debounce } from '../../util';
import { async } from '@antv/x6/lib/registry/marker/async';
import { Selection } from "@antv/x6-plugin-selection";
import { factory } from 'typescript';
import { setTimeout } from 'timers';
import deleteIcon from '../../static/image/delete.png'
import { memosModule } from '../../modules/memos'
import Users from '../../components/memos/users'
// import TagMetaMenu from '../../components/memos/index'
import MemoModal from '../../components/memos/memoModal'
import SelectTag from '../../components/memos/selectTag'

import { create } from 'domain';
import moment from "moment";
//使用教程https://blog.csdn.net/weixin_42737733/article/details/116057505
import MDEditor from '@uiw/react-md-editor';
import Chat from '../../components/chat';
import ImageOverlays from '../../components/ImageOverlays/index';

import { memoadduser } from '../../api/chat'
import Upload from '../../components/upload'

import Preview from '../../components/memos/markDownPreview';
import chat from '../../static/image/chat.png';
import img_label from '../../static/image/label.png';

import comment_a from './comment_a.png';
import CreatePop from '../../components/chat/createpop';
import InitUpload from '../../components/upload';
import TaskTagPop from '../../components/memos/taskTagPop';
import MarkDownPop from '../../components/memos/markDownPop';
import LableDrawer from '../../components/memos/drawer'

import ImgPreview from '../../components/memos/imgPreview'

interface Props {
    history: any;
}
let graph: any = null
let diskMenuShow: any
let edgeMenuShow: any
// let isClickTak:any = false
//设置关系注释可见文字长度
let setLablesNum: any = 5
//防抖，区别单机双击
let timer: any = null
const { TextArea } = Input;
interface State {
    txtStr: any
}
const Memo = (props: Props,) => {
    // 初始，mounted生命周期时, container组件还没挂载。
    const [container, setcontainer] = useState<HTMLElement>(document.createElement('container'));
    const [minimap, setminimap] = useState<HTMLElement>(document.createElement('minimap'));

    const [nodeArr, setNodeArr] = useState<any>([]);

    const [userInfo, setUserInfo] = useState<any>();
    const { store, dispatch } = useStore();
    const [visibleModal, setVisibleModal] = useState<boolean>(false);
    const [taskVisible, setTaskVisible] = useState<boolean>(false);

    const [isDeletExecutor, setIsDeletExecutor] = useState<boolean>(false);

    // const [memoModal, setMemoModal] = useState<boolean>(false);
    const [ImageTagModal, setImageTagModal] = useState<any>('');

    const [isAdd, setIsAdd] = useState<boolean>(false);
    //操作类型
    const [operationType, setOperationType] = useState<any>('');
    // const [operationName, setOperationName] = useState<any>('');
    const [taskType, setTaskType] = useState<any>({});
    // const [taskList, setTaskList] = useState<any>([]);
    const taskList = useRef<any>([]);

    // const [taskInfo, setTaskInfo] = useState<any>({});
    const [finishTime, setFinishTime] = useState<any>('');
    const [userList, setUserList] = useState<any>([]);
    const [usersVisible, setUsersVisible] = useState<boolean>(false);
    const [markDown, setMarkDown] = useState<any>('');
    const [markDownVisible, setMarkDownVisible] = useState<boolean>(false);
    const [imgPreview, setImgPreview] = useState<boolean>(false);

    const [executorInfo, setExecutorInfo] = useState<any>({});
    const [memoInfo, setMemoInfo] = useState<any>({});

    const [previewVisible, setPreviewVisible] = useState<boolean>(false);
    const [imgNotesTagNextStep, setImgNotesTagNextStep] = useState<boolean>(false);
    const [subjeckPrivate, setSubjeckPrivate] = useState<any>(false);
    const [modalBoxShow, setModalBoxShow] = useState<any>(false);
    const [tagVisible, setTagVisible] = useState<any>(false);

    // const [isGroup, setIsGroup] = useState<any>(true);
    //是否是群组移动
    let isGroup: any = false
    //是否是添加节点进入群组，true是移入，false是移出
    let isGroupAdd: any = false

    const today = moment(); // 当天日期

    // const isClickTak = useRef<boolean>(false);
    const [txt, setTxt] = useState<any>('');
    //便签移动次数
    let moveNums = 0
    // const inputRef = useRef<any>()
    const titleRef = useRef<any>()
    // const comments=useRef<any>()
    // let txt: any
    let comments: any
    let subjectData = useRef<any>();
    let mousePosition = useRef<any>();
    let memoId = useRef<String[]>([]);
    let cNode = useRef<any>({});
    let label = useRef<any>('');
    //是否高亮关系
    const isHighlight = useRef<any>(false);

    const relationMenuShow = useRef<any>(false);
    const selectedCells = useRef<any>([]);
    const [addThemeVisible, setAddThemeVisible] = useState<boolean>(false);
    const [subjectTitle, setSubjectTitle] = useState<any>('');
    const [chatDiscussionId, setchatDiscussionId] = useState<string>('');
    const [ownerId, setOwnerId] = useState<string>('');
    //图片格式
    const [imgId, setImgId] = useState<string>('');
    //图片标注
    const [taskInfo, setTaskInfo] = useState<any>({});
    const [permissionsList, setPermissionsList] = useState<any>([]);


    const selectedEdgeCells = useRef<any>([]);
    const isCopy = useRef<boolean>(false);
    const [visibleLabel, setVisibleLabel] = useState<boolean>(false);
    // const visibleLabel = useRef<boolean>(false);


    const [form] = Form.useForm();
    let codeArr: any = [];
    const [state, setState] = useState<State>({
        txtStr: ''
    })
    const onKeyDown = (e: any) => {
        //console.log(e.keyCode)
        let codeKeys: any = [
            17, 13, 67, 86, 91]
        if (!codeKeys.some((i: any) => e.keyCode === i) || codeArr.length > 2) {
            codeArr = []
            return
        }
        if (codeArr[0] == 13) {
            codeArr = []
            //console.log("走到这里了 第一个是13", codeArr)
            return
        }
        if (codeArr.indexOf(e.keyCode) < 0) {
            codeArr.push(e.keyCode)
        }

        if (store.memoModal && codeArr[0] === 17 && codeArr[1] === 13) {
            codeArr = []
            //console.log('按下ctrl+enter键了', state.txtStr)
            saveNode('memos')

        }
        if (store.markDownVisible && codeArr[0] === 17 && codeArr[1] === 13) {
            codeArr = []
            //console.log('按下ctrl+enter键了', state.txtStr)
            putMarkDown()
        }
        if ((codeArr[0] === 17 || codeArr[0] === 91) && codeArr[1] === 67) {
            codeArr = []
            //console.log('按下ctrl+c键了',)
            isCopy.current = true
        }
        if ((codeArr[0] === 17 || codeArr[0] === 91) && codeArr[1] === 86) {
            codeArr = []
            //console.log('按下ctrl+v键了', document.getElementsByClassName("ant-modal-mask"), document.getElementsByClassName("ant-modal-mask").length)
            let antModalMask: any = document.getElementsByClassName("ant-modal-mask").length
            if (isCopy.current && antModalMask == 0) {
                const cells = graph.getSelectedCells()
                //console.log(cells)
                graph.cleanSelection()
                graph.select(cells)
                createNode('memos', 'copy')
            }
        }
    }
    useEffect(() => {
        //初始化 清空前主题遗留数据
        dispatch({
            type: 'SET_CLOSESHOWALL',
            data: null
        });
        // dispatch({
        //     type: 'SET_SHOWCHAT',
        //     data: false
        // });
        setUserInfo(StorageModule.getUser().user);
        console.log('清空画布')
        graph && graph.clearCells()
        memoId.current = []
        selectedCells.current = []
        selectedEdgeCells.current = []
        setCNode(null)
        getId()
        graph && graph.cleanSelection()
        if (store.subjectInfo.subjectId) {
            getDetail(store.subjectInfo.subjectId)
            onCreateListener(store.subjectInfo.subjectId)
            getSonSubject(store.subjectInfo.subjectId)
        } else {
            let user: any = StorageModule.getUser().user
            let id: any = user?.attachInfo?.userTopicDesktop?.rootTopicId
            if (id) {
                getDetail(id)
                onCreateListener(id)
            }
        }

    }, [store.subjectInfo.subjectId, store.rerenderCount])

    useEffect(() => {

        window.addEventListener('keydown', onKeyDown, this) // 添加全局事件
        return () => {
            window.removeEventListener('keydown', onKeyDown, this) // 销毁
        }
    }, [store.memoModal])
    useEffect(() => {

        window.addEventListener('keydown', onKeyDown, this) // 添加全局事件
        return () => {
            window.removeEventListener('keydown', onKeyDown, this) // 销毁
        }
    }, [store.markDownVisible])


    useEffect(() => {
        // v6内部数据不同步用window同步
        (window as any).cdi = store.chatDiscussionId;
        (window as any).showDrawLabel = store.showDrawLabel;
        (window as any).showChat = store.showChat;
        (window as any).memoInfo = store.memoInfo;
        setchatDiscussionId(store.chatDiscussionId);
    }, [store.chatDiscussionId, store.showDrawLabel, store.showChat, store.memoInfo]);


    // useEffect(() => {
    //     //console.log('909089089')
    //     getDetail(store.subjectInfo.subjectId)
    // }, [])

    useEffect(() => {
        //console.log('监听共享主题是否被移除', store.userRemove)
        if (store.userRemove) {
            //当前登录用户，不是主题拥有者，并且也不在users里面，才被通知移除
            if (userInfo?.id === store.subjectInfo.data.owner.id && store.subjectInfo?.data?.users?.some((i: any) => (i === userInfo?.id))) {
                return
            }
            message.warning('您已不在该共享主题！')
            let user: any = StorageModule.getUser().user

            // let id: any = user?.attachInfo?.userTopicDesktop?.rootTopicId
            //新功能 退出共享主题后不再切换到默认主题，而是继续在当前主题，只是权限不同了
            let id: any = store.subjectInfo?.subjectId
            if (id) {
                getDetail(id)
            }
            dispatch({
                type: 'SET_USER_REMOVE',
                data: false
            });
        }
    }, [store.userRemove])

    useEffect(() => {
        if (!imgPreview) {
            reset()
        }
    }, [imgPreview])
    useEffect(() => {
        if (graph && graph.getNodes()) {
            console.log('aaa', selectedCells.current)
            let node = selectedCells.current[0] || null
            // 子主题在父主题的桌面显示时，与父主题中的便签大小相同(颜色不同)，子主题便签显示便签内容，并显示“...”。该状态称之为“状态A”。
            // 用户点击“...”时，切换为现有实现(即“用group列出所有子主题的便签”)，此时子主题便签处于选中状态。
            // 当子主题处于非选中状态时，恢复为状态A。
            graph.getNodes().map((i: any) => {
                //排除当前所选元素，其他group的子节点都清除
                if (i.id != node?.id && i.id.indexOf('group_') > -1) {
                    if (i.data?.data.hasOwnProperty('memos') && i.data?.data?.memos?.length > 0) {
                        console.log('我要删除你 i', i)
                        i.data?.data?.memos.map((j: any) => {
                            console.log('lll', 'groupNode' + i.data.data.id + '_' + j.id)
                            graph.removeCells(['groupNode' + i.data.data.id + '_' + j.id])
                        })
                        let delNode = graph.getCellById(i.id)
                        delNode.setData({ data: { ...delNode.getData(), memos: null } })
                        delNode.size(120, 120)
                    }
                }
            })
        }
    }, [selectedCells.current])
    const reset = () => {
        setIsDeletExecutor(false)
        setImgNotesTagNextStep(false)
        setMarkDown('')
        setImgId('')
        //清除状态
        form.setFieldsValue({
            manHour: null,
            finishTime: null,
            executorId: null,
            release: null,
            imagePath: null,
        });
        form.resetFields();
        dispatch({
            type: 'SET_IMGNOTESTAG',
            data: []
        });
        dispatch({
            type: 'SET_WATCHISMARK',
            data: true
        });
    }
    // const dealImageTag = (params?: any) => {
    //     if (!params) {
    //         params = taskType
    //     }
    //     setImgId('')
    //     // let TaskTag: any = memoInfo.tagMetas?.filter((i: any) => i.notation === 'TaskTag')
    //     // let ImageTag: any = memoInfo.tagMetas?.filter((i: any) => i.notation === 'ImageTag')
    //     // let ImgNotesTag: any = memoInfo.tagMetas?.filter((i: any) => i.notation === 'ImgNotesTag')
    //     let _notation: any = graph && graph.getSelectedCells()[0]?.data.data.tagMetas?.filter((i: any) => i.notation === params.notation)
    //     //console.log('taskType', params,)
    //     //console.log('_notation', _notation)
    //     //console.log('memoInfo', memoInfo)
    //     //console.log('graph && graph.getSelectedCells()[0]?.data', graph && graph.getSelectedCells()[0]?.data)

    //     if (_notation && _notation.length > 0) {
    //         if (params.notation === 'TaskTag') {
    //             let info: any = _notation.filter((i: any) => i.name === params.name)
    //             //console.log(info)
    //             if (info.length > 0) {
    //                 setTaskInfo({ ...info[0] })
    //                 form.setFieldsValue({
    //                     manHour: info[0]?.instance.manHour || null,
    //                     finishTime: info[0].instance ? moment(info[0].finishTime) : null,
    //                     executorId: info[0].instance?.executorId || null,
    //                 });
    //                 setFinishTime(info[0] ? moment(info[0].finishTime) : null)
    //                 setExecutorInfo(info[0].instance.executorUser)
    //             }
    //         } else if (params.notation === 'ImageTag') {
    //             setTaskInfo({ ..._notation[0], title: graph.getSelectedCells()[0].data.label })
    //             form.setFieldsValue({
    //                 title: graph.getSelectedCells()[0].data.label || null,
    //                 imagePath: _notation[0].instance.imagePath || null,
    //             });
    //             setImgId(_notation[0].instance.imagePath)
    //         } else if (params.notation === 'ImgNotesTag') {
    //             if (_notation[0].instance.imagePath != '') {
    //                 setImgNotesTagNextStep(false)
    //             } else {
    //                 setImgNotesTagNextStep(true)
    //             }
    //             setTaskInfo({ ..._notation[0], title: graph.getSelectedCells()[0].data.label })

    //             form.setFieldsValue({
    //                 title: memoInfo.label || null,
    //                 imagePath: _notation[0].instance.imagePath || null,
    //             });
    //             setImgId(_notation[0].instance.imagePath)
    //             let _annotation: any = []
    //             _notation[0].instance.annotation.map((i: any, index: any) => {
    //                 _annotation.push({
    //                     id: index,
    //                     "x": i.x,
    //                     "y": i.y,
    //                     "w": i.w,
    //                     "h": i.h,
    //                     isCompile: false,
    //                     subject: i.description,
    //                     "description": i.description,
    //                     isSelect: false,
    //                     isCheck: false
    //                 })
    //             })
    //             dispatch({
    //                 type: 'SET_IMGNOTESTAG',
    //                 data: _annotation
    //             });
    //         }

    //     } else {

    //         if (params.notation === 'TaskTag') {
    //             setExecutorInfo({})
    //         } else if (params.notation === 'ImageTag') {
    //             form.setFieldsValue({
    //                 title: graph.getSelectedCells()[0].data.label || null,
    //                 imagePath: null,
    //             });
    //             setTaskInfo({ title: graph && graph.getSelectedCells()[0].data.label })
    //         } else if (params.notation === 'ImgNotesTag') {
    //             form.setFieldsValue({
    //                 title: graph.getSelectedCells()[0].data.label || null,
    //                 imagePath: null,
    //             });
    //             setTaskInfo({ title: graph && graph.getSelectedCells()[0].data.label })
    //             setImgNotesTagNextStep(true)
    //         }
    //     }

    // }
    useEffect(() => {
        if (store.markDownVisible) {
            //console.log(store.memoInfo?.data?.content)
            setMarkDown(store.memoInfo?.data?.content)
        } else {
            setMarkDown('')
        }
    }, [store.markDownVisible])
    useEffect(() => {
        if (store.pingMemo && JSON.stringify(store.pingMemo) != '{}' && graph) {
            console.log('store.pingMemo')
            const { x = 0, y = 0 } = graph.getCellById(store.pingMemo.data.id)?.prop().position || {}
            const width = (window.innerWidth - 480) / 2;
            const height = (window.innerHeight - 100) / 2;
            (window as any).graphItem.translate(width - x, height - y);
            // graph && graph.translate(690, 920);
            selectedCells.current = []
            graph.cleanSelection()
            graph.select(store.pingMemo.data.id)
            dispatch({
                type: 'SET_MEMOINFO',
                data: store.pingMemo
            });
        }
    }, [store.pingMemo])

    useEffect(() => {
        //便签注释自动聚焦
        if (store.memoModal) {
            // setTimeout(() => {
            //     inputRef.current.focus({
            //         cursor: 'end',
            //     });
            // }, 500);
        }
        if (addThemeVisible) {
            setTimeout(() => {
                titleRef.current.focus({
                    cursor: 'end',
                });
            }, 500);
        }
    }, [store.memoModal, titleRef, addThemeVisible])
    // useEffect(() => {
    //     //console.log('operationType', operationType)
    //     if (operationType === 'memos') {
    //         setOperationName('便签')
    //     } else if (operationType === 'comments') {
    //         setOperationName('注释')
    //     } else if (operationType === 'relationBelongTos') {
    //         setOperationName('关系说明')
    //     }
    // }, [operationType])

    useEffect(() => {
        if (graph && store.subjectInfo.data) {
            subjectData.current = store.subjectInfo.data
        }
        // getDetail(store.subjectInfo.subjectId)
    }, [store.subjectInfo.data])
    useEffect(() => {
        if (graph && store.subjectInfoPart) {
            // setTimeout(() => {
            dealSave(store.subjectInfoPart)
            // }, 200)
        }

    }, [store.subjectInfoPart])

    //监听显示隐藏
    useEffect(() => {
        if (diskMenuShow) {
            diskMenuShow.setData({ ...diskMenuShow.data, isShow: store.showNode })
            showNodeVisible(store.showNode,)
        }
    }, [store.showNode])

    useEffect(() => {
        console.log('graphInit', store.subjectInfo)
        graphInit()

        // menuInit()
        nodeClick()
        blankContextmenu()
        nodeDbClick()
        nodeContextmenu()
        nodeMoved()
        nodeChanged()
    }, [graph, store.subjectInfo.subjectId]
    )

    //创建监听
    const onCreateListener = async (id: any) => {

        try {
            let res: any = await apis.createListener(id)
        } catch (e) { }
    }
    //获取子主题
    const getSonSubject = async (id: any) => {
        let res: any = await apis.excellingTopic({ parent: id });
        res.data.map(async (i: any, index: any) => {
            // let obj: any = await apis.getExcellingTopic(i.id)
            graphAddGroup(graph, i, index * 130, 0)
            // if (obj.data?.memos?.length > 4) {
            //     graphAddGroup(graph, obj.data, index * 150, 0, 25 * (obj.data?.memos?.length + 1))
            // } else {
            //     graphAddGroup(graph, obj.data, index * 150, 0)
            // }
            // if (graph.getCellById(i.id)) {
            //     let _parent = graph.getCellById(i.id)
            //     console.log('obj.data?.memos', obj.data, i.id)
            //     obj.data?.memos?.map((j: any, jdx: any) => {
            //         _parent.addChild(graphAddGroupNode(graph, i.id, j, _parent.position().x + 10, jdx === 0 ? 30 : 30 + 22 * jdx))
            //     })
            // }
        })
    }
    //获得子主题便签
    const getSonSubjectMemos = async (id: any) => {
        let _id = id
        _id = _id.substring(6, _id.length)
        let obj: any = await apis.getExcellingTopic(_id)
        let _parent = graph.getCellById(id)
        let _height = obj.data?.memos.length > 4 ? obj.data?.memos.length * 22 + 30 : 120
        graph.getCellById(id).size(120, obj.data?.memos.length > 4 ? _height + 25 : _height)

        obj.data?.memos?.map((i: any, index: any) => {
            let cellId = graph.getCellById(`groupNode${id}_` + i.id)
            if (!cellId) {
                console.log('_height', _height)
                _parent.addChild(graphAddGroupNode(graph, id, i, _parent.position().x + 10, index === 0 ? _parent.position().y + 30 : 30 + _parent.position().y + 22 * index))
            } else {
                console.log('graph.getCellById(cellId).getData()',)
                graph.getCellById(cellId).position(10, 30 + 22 * index, { relative: true })
            }
            graph.getCellById(`groupNode${id}_` + i.id) && graph.getCellById(`groupNode${id}_` + i.id).toFront()
            // _parent.addChild(graphAddGroupNode(graph, id, j, _parent.position().x + 10, jdx === 0 ? 30 : 30 + 22 * jdx))
        })
        _parent.setData({ data: obj.data, init: false })
    }
    const getTagMeta = async (data?: any) => {
        try {
            let res: any = await apis.tagMeta()
            if (res.ok) {
                // console.log(JSON.stringify(res.data))
                dispatch({
                    type: 'SET_TAGMETA',
                    data: res.data
                });
                //清空选区
                dealSave(data)
                dispatch({
                    type: 'SET_SHOWNODE',
                    data: false
                });
            }
        } catch {

        }
    }
    const onGetUserList = async () => {

        try {
            let res: any = await getUserList({ enabled: true })
            if (res.ok) {
                const list = res.data.list.filter((item: any) => item.id !== ownerId)
                //console.log('getDetail===', list, ownerId)
                setUserList(res.data.list)
            }
        } catch { }
    }
    /**
     * 主题详情
     */
    const getDetail = async (id: any, node?: any) => {
        try {
            await memosModule.getDetail(id).then((res) => {

                if (res.ok) {
                    getTagMeta(res.data)
                    onGetUserList()
                    setOwnerId(res.data.owner.id)
                    isHighlight.current = true
                }
            }).catch((e) => {
                //console.log(e)
                dealErr(e)
            })

        } catch (e: any) {
            //console.log(e.code)
            dealErr(e)

        }
    }
    const dealErr = (e: any) => {
        if (e.code === 404) {
            let user: any = StorageModule.getUser().user
            let id: any = user?.attachInfo?.userTopicDesktop?.rootTopicId
            if (id) {
                getDetail(id)
            }
        }
    }
    //type==init 代表初始化，是从详情获取，不是通过ws获取
    const dealSave = (res: any, type?: any) => {
        graph.enablePanning()
        //需要循环传来的res，因为可能传回多个。例如批量复制，移动等
        console.log('dealSave', res, store.subjectInfo.subjectId)
        setPermissionsList(res.permissions)
        if (res.id !== store.subjectInfo.subjectId) {
            return
        }
        //console.log('isHighlight', isHighlight.current)
        if (JSON.stringify(res) === '{}') {
            return
        }
        // //console.log('便签渲染开始', )
        // if (cellView.cell.getData() != undefined && !cellView.cell.getData().disableMove) {
        //   return { nodeMovable: false }
        // }
        //权限管理
        // let _permissions = store.subjectInfo?.data?.permissions || res.permissions
        // let isMemo_move = _permissions.some((i: any) => i == 'memo_move')
        // let isComment_move = _permissions.some((i: any) => i == 'comment_move')
        console.log('res.memos', res.memos)
        res.memos && res.memos.map((i: any, index: any) => {
            //console.log(i.$operate$, i.visible, i.id, graph.getCellById(i.id))
            //console.log('graph.getCells()', graph.getCells())
            if (i.visible && !graph.getCellById(i.id) && i.$operate$ !== 'delete' && i.$operate$ !== 'remove') {
                console.log('新建可视便签', i)
                graphAddNodeMemo(graph, i)
                // let _nodeMovable = isMemo_move
                // graph.getCellById(i.id) && graph.getCellById(i.id).setData({ ...graph.getCellById(i.id).data, nodeMovable: _nodeMovable })
                graph.getCellById(i.id) && graph.getCellById(i.id).setData({ ...graph.getCellById(i.id).data, })

            } else if ((!i.visible && !store.showNode) || i.$operate$ == 'delete') {
                //console.log('删除便签',)
                graph.getCellById(i.id) && graph.removeCells([i.id])
            } else {
                console.log('更新便签')
                if (i.$operate$ !== 'delete' && i.$operate$ !== 'remove') {
                    console.log(i)
                    graph.getCellById(i.id).data.data = i
                    graph.getCellById(i.id) && graph.getCellById(i.id).setData({ ...graph.getCellById(i.id).data, tagMetas: i.tagMetas })
                    graph.getCellById(i.id) && graph.getCellById(i.id).prop('position', { x: i.x, y: i.y })
                    graph.getCellById(i.id) && graph.getCellById(i.id).prop('data/label', i.content)
                    graph.getCellById(i.id) && graph.getCellById(i.id).prop('tagMetas', i.tagMetas)
                    //console.log('graph.getCellById(i.id)', graph.getCellById(i.id))
                }
            }
            graph.getCellById(i.id) && graph.getCellById(i.id).toFront()
            // graph.getCellById(i.id) && graph.getCellById(i.id).setData({ nodeMovable: true })

        })

        //console.log('便签渲染结束', new Date().toLocaleDateString().replace(/\//g, "-") + " " + new Date().toTimeString().substr(0, 8))
        //console.log('关系渲染开始', new Date().toLocaleDateString().replace(/\//g, "-") + " " + new Date().toTimeString().substr(0, 8))
        //console.log(res.relationBelongTos)
        res.relationBelongTos && res.relationBelongTos.map((i: any, index: any) => {

            if ((!i.visible && !store.showNode) || i.$operate$ == "delete") {
                //console.log('走这里了222', i.content)
                graph.getCellById(i.id) && graph.removeCells([i.id])
            } else {
                graphAddEdge(graph, i, 'delayShowRelation')
                console.log('修改关系', i, graph.getCellById(i.id))
                graph.getCellById(i.id) && graph.getCellById(i.id).removeLabelAt(0)
                if (i.content !== '') {
                    console.log("走这个了")
                    graph.getCellById(i.id) && graph.getCellById(i.id).appendLabel(i.content)
                    console.log(graph.getCellById(i.id) && graph.getCellById(i.id).getLabels())
                }

                graph.getEdges().map((j: any) => {
                    if (!isHighlight.current && i.id === j.id) {
                        j.attr("line/strokeDasharray", 0)
                        j.attr("line/stroke", '#faad14')
                    }
                })

            }

            graph.getCellById(i.id) && graph.getCellById(i.id).prop('source/cell', i.suborId)
            graph.getCellById(i.id) && graph.getCellById(i.id).prop('target/cell', i.superId)
            //更新关系data
            graph.getCellById(i.id) && graph.getCellById(i.id).setData({ data: { ...i } })

        })
        isHighlight.current = true
        //console.log('关系渲染结束', new Date().toLocaleDateString().replace(/\//g, "-") + " " + new Date().toTimeString().substr(0, 8))
        //console.log('注释渲染开始', new Date().toLocaleDateString().replace(/\//g, "-") + " " + new Date().toTimeString().substr(0, 8))
        res.comments && res.comments.map((i: any, index: any) => {
            //console.log(graph.getCellById(i.id), i.id)
            //console.log('graph.getCells()', graph.getCells())
            if (i.visible && !graph.getCellById(i.id) && i.$operate$ !== 'delete') {
                //console.log('添加注释')
                // i.content = '111<br/>333'
                graphAddNodeComment(graph, i)
                // let _isComment_move = isComment_move
                // graph.getCellById(i.id) && graph.getCellById(i.id).setData({ ...graph.getCellById(i.id).data, nodeMovable: _isComment_move })
                graph.getCellById(i.id) && graph.getCellById(i.id).setData({ ...graph.getCellById(i.id).data, })

                // graph.addNode({
                //     shape: "comment-node",
                //     data: {
                //         type: 'comments',
                //         label: (i.content === '') ? ' ' : i.content,
                //         menuShow: false,
                //         isEdit: false,
                //         isActive: false,
                //         data: i,
                //         recoverVisible: false,
                //     },
                //     id: i.id,
                //     x: i.x,
                //     y: i.y,
                //     ...nodeCommentInit,
                // });
            } else if ((!i.visible && !store.showNode) || i.$operate$ == 'delete') {
                //console.log('删除注释')
                graph.getCellById(i.id) && graph.removeCells([i.id])
            } else {
                //console.log('更新注释')
                graph.getCellById(i.id).data.data = i
                graph.getCellById(i.id) && graph.getCellById(i.id).setData({ ...graph.getCellById(i.id).data, })
                graph.getCellById(i.id) && graph.getCellById(i.id).prop('position', { x: i.x, y: i.y })
                graph.getCellById(i.id) && graph.getCellById(i.id).prop('data/label', i.content)
            }
        })
        //console.log('注释渲染结束', new Date().toLocaleDateString().replace(/\//g, "-") + " " + new Date().toTimeString().substr(0, 8))
        // if (res.memos.length === 1) {
        //     dispatch({
        //         type: 'SET_MEMOINFO',
        //         data: { ...store.memoInfo, data: res.memos[0] }
        //     });
        // }
        if (store.pingMemo && JSON.stringify(store.pingMemo) != '{}') {
            console.log('store.pingMemo2')
            const { x = 0, y = 0 } = graph.getCellById(store.pingMemo.data.id).prop().position || {}
            const width = (window.innerWidth - 480) / 2;
            const height = (window.innerHeight - 100) / 2;
            (window as any).graphItem.translate(width - x, height - y);
            // graph && graph.translate(690, 920);
            graph.select(store.pingMemo.data.id)
            dispatch({
                type: 'SET_MEMOINFO',
                data: store.pingMemo
            });
        }

        dispatch({
            type: 'SET_MEMOINFO',
            data: { data: res.memos[0] }
        });
        //graph.cleanSelection()
        ////console.log("node:selected", graph.getSelectedCells());
        //graph.resetSelection(graph.getSelectedCells())
        //selectedCells.current = []
        isCopy.current = false
        dispatch({
            type: 'SET_MEMOS_NUM',
            data: graph.getSelectedCells().length
        });
    }
    /**
     * 
     * @param params 保存主题
     */
    const saveSubject = async (params: any, node?: any,) => {
        dealHide(null, 'menu', node)
        //console.log(JSON.stringify(params))
        try {

            let res: any = await apis.putExcellingTopic(params.id, params)
            if (res.ok) {
                // getDetail(subjectData.current?.id, node)
                // memoId.current.shift()
                // setMemoId(memoId)
                moveNums = 0
                if (memoId.current.length == 0) {
                    getId()
                }

            }
            selectedCells.current = []
        } catch (e) {
            selectedCells.current = []
        }

    }
    /**保存群组 */
    const saveGroupSubject = async (params: any, node?: any, type?: any) => {

        dealHide(null, 'menu', node)
        // 
        //console.log(JSON.stringify(params))
        try {

            let res: any = await apis.putExcellingTopic(params.id, params)
            if (res.ok) {
                // getDetail(subjectData.current?.id, node)
                // memoId.current.shift()
                // setMemoId(memoId)
                moveNums = 0
                if (memoId.current.length == 0) {
                    getId()
                }
                if (type == 'remove') {
                    let _height = graph.getCellById(node.id).size().height - 25
                    graph.getCellById(node.id).size(120, _height > 120 ? _height : 120)
                    let childrenList: any = graph.getCellById(node.id)?._children
                    console.log(childrenList)
                    childrenList.map((i: any, index: any) => {
                        graph.getCellById(i.id).position(10, 30 + 22 * index, { relative: true })
                    })
                }
            }
            setModalBoxShow(false)
        } catch (e) {
            setModalBoxShow(false)
        }
    }
    const updateGroupNode = async (node: any) => {
        let _id = node.id
        _id = _id.substring(6, _id.length)
        let obj: any = await apis.getExcellingTopic(_id)
        // console.log('updateGroupNode', obj)
        // let _parent = graph.getCellById(node.id)
        // console.log('updateGroupNode_parent', _parent, selectedCells.current[0])
        // let _height = obj.data?.memos.length > 4 ? graph.getCellById(node.id).size().height : 120
        // obj.data?.memos?.map((i: any, index: any) => {
        //     let cellId = graph.getCellById(`groupNode${node.id}_` + i.id)
        //     if (!cellId) {
        //         console.log('_height', _height)
        //         graph.getCellById(node.id).size(120, obj.data?.memos.length > 4 ? _height + 25 : _height)
        //         _parent.addChild(graphAddGroupNode(graph, node.id, i, _parent.position().x + 10, index === 0 ? _parent.position().y + 30 : 30 + _parent.position().y + 22 * index))
        //     } else {
        //         console.log('graph.getCellById(cellId).getData()',)
        //         graph.getCellById(cellId).position(10, 30 + 22 * index, { relative: true })
        //     }
        //     graph.getCellById(`groupNode${node.id}_` + i.id) && graph.getCellById(`groupNode${node.id}_` + i.id).toFront()
        // })
    }
    /**
     * 桌面菜单
     */
    const DiskMenu = ({ node }: { node: Node, }) => {
        const { isShow } = node.data
        //是否有操作权限
        //新增memo
        let isMemo_insert = permissionsList.some((i: any) => i == 'memo_insert')
        //新增注释
        let iScomment_insert = permissionsList.some((i: any) => i == 'comment_insert')
        console.log('DiskMenuisShow', isShow, node.isVisible())
        return (
            <div id="DiskMenuisShow">
                <Dropdown visible={true} overlay={
                    <Menu>
                        <Menu.Item disabled={!isMemo_insert} onClick={() => {
                            // createNode('memos')
                            setTxt('')
                            state.txtStr = ''
                            setState(state)
                            setOperationType('memos')
                            setIsAdd(true)
                            setMemoModal(true, 'memos', true)
                        }}><PlusSquareOutlined className='mr-5' />新建便签</Menu.Item>
                        {/* <Menu.Item>保存主题</Menu.Item> */}
                        <Menu.Item disabled={!iScomment_insert} onClick={() => {
                            // 
                            setTxt('')
                            state.txtStr = ''
                            setState(state)
                            setOperationType('comments')
                            setMemoModal(true, 'comments', true)
                            setIsAdd(true)

                        }}><MessageOutlined className='mr-5' />添加注释</Menu.Item>
                        {!isShow && <Menu.Item onClick={() => {
                            showNodeVisible(true, node)
                            dispatch({
                                type: 'SET_SHOWNODE',
                                data: true
                            });
                        }}><EyeOutlined className='mr-5' />显示隐藏项</Menu.Item>}
                        {isShow && <Menu.Item onClick={() => {
                            showNodeVisible(false, node)
                            dispatch({
                                type: 'SET_SHOWNODE',
                                data: false
                            });
                        }}><EyeInvisibleOutlined className='mr-5' />恢复隐藏</Menu.Item>}
                        <Menu.Item onClick={() => {
                            // graph.zoom()
                            graph.centerContent();
                            menuCancel()

                        }}><PlusSquareOutlined className='mr-5' />居中</Menu.Item>

                    </Menu>
                } trigger={['contextMenu',]}>
                    <div className={`${style.diskMenu}`} ></div>
                </Dropdown>
                {/* {id} */}
            </div>
        )
    }
    /**
     * 注册桌面菜单工具
     */
    register({
        shape: 'disk-menu',
        width: 120,
        height: 50,
        effect: ["data"],
        component: DiskMenu
    })
    /**
     * 注册桌面菜单工具
     */
    register({
        shape: 'task-menu',
        width: 120,
        height: 50,
        effect: ["data"],
        component: ({ node }: { node: Node, }) => {
            return (<>
                11
                2
                3</>)
        }
    })
    /**
     * 注册edge菜单工具
     */
    register({
        shape: 'edge-menu',
        width: 120,
        height: 50,
        effect: ["data"],
        component: ({ node }: { node: Node, }) => {
            //console.log(cNode.current?.data?.recoverVisible)
            const recoverVisible = cNode.current?.data?.recoverVisible || false
            let ownerId = selectedCells?.current[0]?.data?.data?.ownerId
            //console.log(userInfo?.id, ownerId)
            let isOwner = (userInfo?.id === ownerId) ? true : false
            //编辑关系
            let isMemo_relation_update = permissionsList.some((i: any) => i == 'memo_relation_update')
            return (
                <>
                    <Dropdown visible={true} overlay={

                        <Menu>
                            <Menu.Item disabled={!isMemo_relation_update} onClick={() => {
                                setOperationType('relationBelongTos')
                                setIsAdd(false)
                                //console.log(cNode)
                                setTxt(store.memoInfo?.data?.content)
                                state.txtStr = store.memoInfo?.data?.content
                                setState(state)
                                // setCNode(node)
                                setMemoModal(true, 'relationBelongTos', false)
                                dealHide(null, 'menu', node)
                            }}><EditOutlined className='mr-5' />编辑</Menu.Item>
                            <Menu.Item disabled={!isMemo_relation_update} onClick={() => {
                                editEdge(selectedCells.current[0], 'reverse')
                            }}><SwapOutlined className='mr-5' />反向</Menu.Item>
                            {recoverVisible ?
                                <Menu.Item disabled={!isMemo_relation_update}
                                    onClick={() => {
                                        nodeVisible('relationBelongTos', node, true)

                                    }}><EyeOutlined className='mr-5' />不隐藏</Menu.Item> : <Menu.Item
                                        disabled={!isMemo_relation_update}
                                        onClick={() => {
                                            nodeVisible('relationBelongTos', node)
                                        }}><EyeInvisibleOutlined className='mr-5' />隐藏</Menu.Item>}
                            {/* <Menu.Item onClick={() => {
                            nodeVisible('relationBelongTos', node)
                        }}>隐藏</Menu.Item> */}
                            {isOwner && <Menu.Item disabled={!isMemo_relation_update} onClick={() => {
                                setVisibleModal(true)
                                dealHide(null, 'menu', node)
                            }}><img src={deleteIcon} style={{ width: '13px' }} className='mr-5' />删除</Menu.Item>}
                        </Menu>
                    } trigger={['contextMenu',]}>
                        <div className={`${style.diskMenu}`} ></div>
                    </Dropdown>
                    {/* {id} */}
                </>
            )
        }
    })
    /***
     * 注册注释节点
     */
    register({
        shape: "comment-node",
        width: 120,
        height: 120,
        component: ({ node }: { node: Node, }) => {
            const { label, menuShow, isEdit, isActive, recoverVisible } = node.data
            const { ownerId } = node?.data.data
            let isOwner = (userInfo?.id === ownerId) ? true : false
            //编辑关系
            let isComment_save = permissionsList.some((i: any) => i == 'comment_save')
            let isComment_insert = permissionsList.some((i: any) => i == 'comment_insert')

            return (<>{
                // !isEdit ?
                menuShow ?
                    <Dropdown visible={true} overlay={<Menu onClick={(e) => {
                    }}>
                        {selectedCells.current.length <= 1 && <Menu.Item
                            disabled={!isComment_save} onClick={() => {
                                setOperationType('comments')
                                setIsAdd(false)
                                setTxt(node.data.label)
                                state.txtStr = node.data.label
                                setState(state)
                                setCNode(node)
                                setMemoModal(true, 'comments', false)
                                dealHide(null, 'menu', node)

                            }}><EditOutlined className='mr-5' />编辑</Menu.Item>}
                        <Menu.Item disabled={!isComment_save} onClick={() => {
                            createNode('comments', 'copy')
                        }}><CopyOutlined className='mr-5' />复制</Menu.Item>
                        {recoverVisible ?
                            <Menu.Item
                                disabled={!isComment_save}
                                onClick={() => {
                                    nodeVisible('comments', node, true)

                                }}><EyeOutlined className='mr-5' />不隐藏</Menu.Item> : <Menu.Item
                                    disabled={!isComment_save}
                                    onClick={() => {
                                        nodeVisible('comments', node)
                                    }}><EyeInvisibleOutlined className='mr-5' />隐藏</Menu.Item>}
                        {isOwner && <Menu.Item
                            disabled={!isComment_insert}
                            onClick={() => {
                                setVisibleModal(true)
                                dealHide(null, 'menu', node)
                            }}>
                            <img src={deleteIcon} style={{ width: '13px' }} className='mr-5' />删除
                        </Menu.Item>}
                    </Menu>} trigger={['contextMenu',]}>
                        {CommentNodeHtml(node)}
                    </Dropdown> : CommentNodeHtml(node)

            }
            </>
            );
        },
    });
    const CommentNodeHtml = (node: any) => {
        const { label, menuShow, isEdit, isActive, isMore, releaseTag, } = node?.data
        // //console.log(node?.data)
        return (
            <>
                <div className={`${style.memoNode} ${style.commentNode} ${isActive ? style.active : " "} ${isMore && style.isMore}`}>
                    <div className={style.lable}><div dangerouslySetInnerHTML={{
                        __html: `<div>${label.replace(/\n/g, '</br>')}<div>`
                    }}></div></div>
                    {(!isMore && label.length > 28) && <div className={style.dashoutlined} onClick={() => {
                        // node.size(220, 220);
                        // node.setData({ ...node.data, isMore: true })
                        getConvertHtml(label)
                    }}><DashOutlined /></div>}

                </div>
            </>
        )
    }
    //标签弹出框类型
    const labelPop = (mimeType: any, node?: any) => {
        console.log('labelPop', mimeType, node)
        if (!mimeType) {
            console.log(node)
            // setMemoModal(true, 'memos', false)
            setMemoModal(true, node?.data?.type, false)
        } else {
            setMemoModal(false, node?.data?.type, false)
            dispatch({
                type: 'SET_LABELPOP',
                data: true
            });
        }

    }
    /***
     * 注册便签节点
     */
    register({
        shape: "memo-node",
        // inherit: 'rect', 

        ...nodeInit,
        component: ({ node }: { node: Node, }) => {
            const { label, menuShow, isEdit, isActive, isMore, recoverVisible, } = node.data
            const { ownerId, mimeType, permissions } = node?.data.data
            let isOwner = (userInfo?.id === ownerId) ? true : false
            //是否有操作权限
            // console.log('permissionsList', permissionsList)
            let isRight_opt = permissionsList.some((i: any) => i == 'right_opt')
            // console.log('isRight_opt', isRight_opt)
            //解散讨论后，非本用户创建的便签只能操作隐藏、移动、移除
            let isHasDiscuss = (subjectData.current?.users?.length == 0 && !isOwner) ? false : true
            return (<>{
                menuShow ?
                    <div id="MenuisShow">

                        <Dropdown visible={true} overlay={

                            <Menu onClick={(e) => { }}>
                                {selectedCells.current.length <= 1 && isHasDiscuss && <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    // txt = node.data.label
                                    setOperationType('memos')
                                    setIsAdd(false)
                                    setTxt(node.data.label)
                                    state.txtStr = node.data.label
                                    setState(state)
                                    setCNode(node)
                                    dealHide(null, 'menu', node)
                                    labelPop(mimeType, node)
                                    // if (mimeType === 'text/markdown') {
                                    //     setMarkDownVisible(true)
                                    // }
                                    // if (mimeType === 'image/*' || mimeType === 'image/m2ni-img-notas') {
                                    //     labelPop(mimeType)
                                    // } else {
                                    //     setMemoModal(true)
                                    // }
                                }}><EditOutlined className='mr-5' />编辑</Menu.Item>}
                                {isHasDiscuss && <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    createNode('memos', 'copy')
                                }}><CopyOutlined className='mr-5' />复制</Menu.Item>}
                                {recoverVisible ?
                                    <Menu.Item disabled={!isRight_opt}
                                        onClick={() => {
                                            nodeVisible('memos', node, true)

                                        }}><EyeOutlined className='mr-5' />不隐藏</Menu.Item> : <Menu.Item
                                            disabled={!isRight_opt}
                                            onClick={() => {
                                                nodeVisible('memos', node)
                                            }}><EyeInvisibleOutlined className='mr-5' />隐藏</Menu.Item>}
                                <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    setVisibleModal(true)
                                    dealHide(null, 'menu', node)
                                    setOperationType('remove')
                                }}><MinusCircleOutlined className='mr-5' />移除</Menu.Item>
                                {selectedCells.current.length == 1 && isOwner && <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    setVisibleModal(true)
                                    dealHide(null, 'menu', node)
                                    setOperationType('delete')
                                }}>
                                    <img src={deleteIcon} style={{ width: '13px' }} className='mr-5' />删除
                                </Menu.Item>}
                                {
                                    graph.getSelectedCellCount() === 1 ?
                                        <Menu.Item disabled={!isRight_opt} onClick={() => {
                                            dispatch({
                                                type: 'SET_CHATID',
                                                data: node.id
                                            });
                                            dispatch({
                                                type: 'SET_CHATDISCUSSIONID',
                                                data: node?.data?.data?.discussionId
                                            });
                                            dispatch({
                                                type: 'SET_SHOWCREATECHAT',
                                                data: true
                                            });
                                            dealHide(null, 'menu', node);
                                        }}>
                                            <div className={style.commentitem}>
                                                <img className={style.commenticon + ' mr-5'} src={comment_a} />
                                                讨论
                                            </div>
                                        </Menu.Item> : null
                                }
                                {(selectedCells.current.length === 2) && <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    createNode('relationBelongTos')
                                }}><NodeIndexOutlined className='mr-5' />建关系</Menu.Item>}
                                {isOwner && <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    createSubject(node)
                                }}><ContainerOutlined className='mr-5' />建主题</Menu.Item>}
                                {isHasDiscuss && <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    onBelongTo([node.id], true)
                                    dealHide(null, 'menu', node)
                                }}><LinkOutlined className='mr-5' />查关系</Menu.Item>}
                                {isHasDiscuss && <Menu.Item disabled={!isRight_opt} onClick={() => {
                                    onBelongTo([node.id], false)
                                    dealHide(null, 'menu', node)
                                }}><NodeIndexOutlined className='mr-5' />查主题内关系</Menu.Item>}
                            </Menu>
                        } trigger={['contextMenu',]}>
                            {MemoNodeHtml(node)}

                        </Dropdown></div> :
                    MemoNodeHtml(node)
            }

            </>
            );
        },
    });
    /***
     * 注册群组
     */
    register({
        shape: "group",
        // inherit: 'rect', 
        ...groupInit,
        component: ({ node }: { node: Node, }) => {

            return <>{GroupHtml(node)}</>
        },
    });
    /***
     * 注册群组节点
     */
    register({
        shape: "group-node",
        // inherit: 'rect', 
        ...groupNode,
        component: ({ node }: { node: Node, }) => {

            return <>{GroupNodeHtml(node)}</>
        },
    });
    const GroupHtml = (node: any) => {
        console.log('GroupHtml', node,)
        const { label, menuShow, isEdit, isActive, isMore, releaseTag, } = node?.data
        let _memos = node?.data?.data?.memos || []
        return <>
            <div className={`${style.group}  ${isActive ? style.active : " "} `}>
                <div className={`${style.lable} ${_memos.length > 0 ? 'clamp1' : 'clamp4'}`} >
                    {label}
                </div>
                {_memos.length == 0 && <div className={style.dashoutlined} onClick={() => {
                    graph.getCellById(node.id).setData({ init: true })
                    getSonSubjectMemos(node.id)
                }}><DashOutlined /></div>
                }
            </div>

        </>
    }
    const GroupNodeHtml = (node: any) => {
        // console.log('GroupNodeHtml', node)
        const { label, menuShow, isEdit, isActive, isMore, releaseTag, } = node?.data

        return <>
            <div className={`${style.groupNode} ${isActive ? style.active : " "} `}>
                {label}
            </div>
        </>
    }
    const MemoNodeHtml = (node: any) => {
        const { label, menuShow, isEdit, isActive, isMore, releaseTag, } = node?.data
        const { mimeType } = node?.data?.data
        console.log(node?.data?.data)
        const { tagMetas } = node?.data.data
        let _ImageTag: any = tagMetas?.filter((i: any) => i.notation === 'ImageTag' || i.notation === 'ImgNotesTag') || []
        let _LabelTag: any = tagMetas?.filter((i: any) => i.notation === 'LabelTag') || []
        let _TaskTag: any = tagMetas?.filter((i: any) => i.notation === 'TaskTag') || []
        let _WebPageTag: any = tagMetas?.filter((i: any) => i.notation === 'WebPageTag') || []
        // //console.log('_ImageTag', _ImageTag, tagMetas)
        console.log('_WebPageTag', _WebPageTag)
        let taskColor: any = 'item0'
        if (_TaskTag.length > 0) {
            let _name = _TaskTag[_TaskTag.length - 1].name
            switch (_name) {
                case '任务完成':
                    taskColor = 'item3'
                    break;
                case '开始执行':
                    taskColor = 'item2'
                    break;
                case '任务计划':
                    taskColor = 'item1'
                    break;
            }
        }
        const { ownerId } = node?.data?.data
        // const { avatar } = node?.data?.data?.owner
        const avatar = node?.data?.data?.owner?.avatar || '';
        const tx = avatar
        return (
            <>
                <div className={style.leftCont}>
                    {ownerId !== userInfo?.id && <div className={style.userImg} data-flex='main:center cross:center'>
                        <img alt="" className={style.user_default}
                            src={getImgUrlById(tx)}
                            onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                    </div>}
                    {
                        node?.data?.data?.discussionId ?
                            <img className={style.chaticon}
                                onMouseDown={async (e) => {
                                    e.stopPropagation();
                                    dispatch({
                                        type: 'SET_SHOWCHATTYPE',
                                        data: ''
                                    });
                                    if ((window as any).cdi && ((window as any).cdi === node?.data?.data?.discussionId)) {
                                        dispatch({
                                            type: 'SET_CHATID',
                                            data: ''
                                        });
                                        dispatch({
                                            type: 'SET_CHATDISCUSSIONID',
                                            data: ''
                                        });
                                        dispatch({
                                            type: 'SET_CLOSESHOWALL',
                                            data: null
                                        });
                                    } else {
                                        dispatch({
                                            type: 'SET_CHATID',
                                            data: node.id
                                        });
                                        dispatch({
                                            type: 'SET_CHATDISCUSSIONID',
                                            data: node?.data?.data?.discussionId
                                        });
                                        dispatch({
                                            type: 'SET_CLOSESHOWALL',
                                            data: ['showChat']
                                        });
                                    }
                                }}
                                src={chat} /> : null
                    }
                    {(tagMetas.length > 0) && <img className={style.chaticon} src={img_label}
                        onMouseDown={async (e) => {
                            e.stopPropagation();
                            //console.log(node, (window as any).memoInfo)
                            graph.resetSelection([node?.id])
                            if (node.id === (window as any).memoInfo?.data?.id) {
                                dispatch({
                                    type: 'SET_SHOWDRAWLABEL',
                                    data: !(window as any).showDrawLabel
                                });
                            } else {
                                dispatch({
                                    type: 'SET_SHOWDRAWLABEL',
                                    data: true
                                });
                            }

                            // setVisibleLabel(!(window as any).showDrawLabel)
                        }
                        }
                    />}
                    {/* {_TaskTag && _TaskTag.map((i: any, index: any) => (
                            <div key={index} onClick={(e) => {
                                setTaskVisible(true)
                                taskTab(i)
                            }} className={style.taskItem + ` item${(taskList.current.filter((j: any) => j.name === i.name)[0]?.sortNum)}`}>
                            </div>
                        ))} */}
                </div>

                <div className={`${style.memoNode} ${isActive ? style.active : " "} ${isMore && style.isMore} ${style.item} ${taskColor}`}>
                    {_ImageTag.length > 0 ? <>
                        <div className={`${style.lable} `} >
                            <div className='clamp1'>{label}</div>
                            {/* <Image
                                    className={style.memoImg}
                                    src={getImgUrlById(_ImageTag[0].instance.imagePath)}
                                    fallback={noImg}
                                /> */}
                            <div className={style.memoImg} style={{ backgroundImage: `url(${getImgUrlById(_ImageTag[0].instance.imagePath)})` }}>
                            </div>

                        </div>
                        <div className={style.dashoutlined} onClick={() => {
                            // let task:any=taskList.current.filter((i: any) => i.notation === _ImageTag.notation)
                            //console.log(_ImageTag)
                            // setTaskType({ name: _ImageTag[0].name, notation: _ImageTag[0].notation })
                            // dealImageTag({ name: _ImageTag[0].name, notation: _ImageTag[0].notation })
                            // setImgPreview(true)

                            dispatch({
                                type: 'SET_IMGPREVIEW',
                                data: true
                            });
                        }}><DashOutlined />
                            {/* <Image
                                    className={style.dashoutlinedImg}
                                    src={(_ImageTag[0].instance.imagePath) ? getImgUrlById(_ImageTag[0].instance.imagePath) : noImg}
                                // fallback={noImg}
                                /> */}
                        </div>
                    </> : <>
                        <div className={style.lable}>
                            {mimeType == "text/webpage" ?
                                <div dangerouslySetInnerHTML={{
                                    __html: `<div>${_WebPageTag[0]?.instance?.title}<div>`
                                }}></div> :
                                <div dangerouslySetInnerHTML={{
                                    __html: `<div>${label.replace(/\n/g, '</br>')}<div>`
                                }}></div>}
                        </div>
                        <div data-flex='main:justify cross:center'>
                            <div>
                                {(!isMore && (label.length > 28 || getCharCount(label, '\n') > 3)) && <div className={style.dashoutlined} onClick={() => {
                                    // node.size(220, 220);
                                    // node.setData({ ...node.data, isMore: true })
                                    getConvertHtml(label)
                                }}><DashOutlined /> </div>}
                            </div>
                            {_LabelTag.length > 0 && <div className='tag tag1 clamp1'>{_LabelTag[_LabelTag.length - 1].instance.markValue}</div>}</div>
                    </>}

                </div>

            </>
        )
    }

    const getId = async () => {
        try {
            let res: any = await apis.sequenceSerial()
            if (res.ok) {
                memoId.current = memoId.current.concat(res.data)
            }
        } catch (e) { }
    }
    const editEdge = async (node: any, type: any) => {
        try {
            let params: any
            let target: any = node.target.cell
            let source: any = node.source.cell
            if (type === 'reverse') {
                //console.log(node.data)
                params = {
                    "superId": node.source.cell,
                    "suborId": node.target.cell,
                    "content": node.data.label,
                    ownerId: userInfo?.id,
                    visible: node.data.data.visible
                }
            }
            let res: any = await apis.putBelong(node.id, params)
            if (res.ok) {
                // 3129282470871040
                node.prop("source/cell", target);
                node.prop("target/cell", source);

            }
        } catch (e) { }
        // graph.addEdge({
        //     id: i.id,
        //     data: {
        //         type: 'relationBelongTos',
        //         label: (i.content === '') ? ' ' : i.content,
        //         menuShow: false,
        //         isEdit: false
        //     },
        //     zIndex: 1,
        //     source: i.superId,
        //     target: i.suborId,
        //     ...edgeInit
        // });
    }
    /**
                    * 查关系
                    */
    const onBelongTo = async (arr: any, type?: any) => {
        menuCancel()
        try {
            let params: any = {}
            let res: any
            if (selectedCells.current.length > 0) {
                let nArr: any = []
                selectedCells.current.map((i: any) => {
                    nArr.push(i.id)
                })
                params = { ...params, memoId: nArr }
            } else {
                params = { ...params, memoId: arr }
            }
            // let graphInfo: any = localStorage.getItem('things_x6_container')
            //console.log(cNode.current)
            // return
            //xy为当前查便签的坐标
            params = { ...params, global: type, x: cNode.current?.prop().position.x, y: cNode.current?.prop().position.y }
            res = await apis.getBelongTo(subjectData.current?.id, params)

            if (res.ok) {
                isHighlight.current = false
                // res.data.map((i: any) => {
                //     //console.log(graph.getCellById(i.id))
                // })
            }
        } catch (e) {

        }
    }
    /**
     * 建子主题，默认父主题为当前主题
     * 当选中一个主题时，新建主题名称默认内容为它的内容，如果改变主题名称，则默认在新主题内新建一个便签。
     * 当选中多个主题时，新建主题名称自定义，并在新主题内新增选中的便签
     * 建主题成功后，选中便签都移除。
     */
    const createSubject = (node: any) => {
        dealHide(null, 'menu', node)


        if (selectedCells.current.length === 1) {
            setSubjectTitle(selectedCells.current[0].data.label)
            saveSonSubject('one')
        } else {
            setAddThemeVisible(true)
            setSubjectTitle('')
        }
    }
    /*
    * 打开计划
    */
    const openTask = (i: any) => {
        if (graph && graph.getSelectedCells().length == 1) {
            let isOwn: any = graph.getSelectedCells()[0].data.data.ownerId === userInfo.id
            //console.log(isOwn, store.subjectInfo.data.users)

            if (i.notation === 'MarkdownTag' || i.notation === 'ImageTag' || i.notation === 'ImgNotesTag') {
                if (!isOwn && store.subjectInfo.data.users.length == 0) {
                    message.warning('只能操作自己的markdown格式/图片格式/图片标注类型的便签')

                } else {
                    labelPop(i.mimeType)
                }
            } else {
                setTaskVisible(true)
            }


        } else {
            message.warning('只能选一个便签')
        }
    }
    const taskTab = (i: any) => {
        let info: any = {}
        if (i.name === '任务计划') {
            info = { ...i, label1: '计划完成时间', label2: '预计工时' }
        } else if (i.name === '开始执行') {
            info = { ...i, label1: '预计完成时间', label2: '预计工时' }
        }
        else if (i.name === '任务完成') {
            info = { ...i, label1: '实际完成时间', label2: '实际工时' }
        }
        else if (i.name === '版本计划') {
            info = { ...i, label1: '版本号', }
        }
        else {
            info = { ...i, }
        }
        dispatch({
            type: 'SET_SELECTTAGMETA',
            data: info
        });
    }
    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        //console.log(date, dateString);
        if (!date) {
            form.resetFields(['finishTime'])
        }
        setFinishTime(dateString)
    };
    /**
     * 查看markDown转换内容
     */
    const getConvertHtml = (data: any) => {
        setMarkDown(data)
        setPreviewVisible(true)
        // try {
        //     //console.log(data)
        //     if (!data.data.mimeType) {
        //         setMarkDown(data.label)
        //         setPreviewVisible(true)
        //     } else {
        //         let res: any = await apis.convertHtml({
        //             mimeType: data.data.mimeType,
        //             content: data.label
        //         })
        //         if (res.ok) {
        //             setMarkDown(res.data)
        //             setPreviewVisible(true)
        //         }
        //     }

        // } catch { }
    }
    /**
    * 新建/修改markDown内容
    * @returns 
    */
    const putMarkDown = async () => {
        try {
            let memo: any = graph && graph.getSelectedCells()[0]
            //console.log(typeof markDown, markDown)
            let res: any = await apis.putMemoNotation(memo.id, 'MarkdownTag', { content: markDown })
            if (res.ok) {
                // setMarkDownVisible(false)
                dispatch({
                    type: 'SET_MARKDOWNVISIBLE',
                    data: false
                });
            } else {

            }
        } catch { }
    }
    // /**
    // * 新建/修改任务计划
    // * @returns 
    // */
    // const addTask = async () => {
    //     try {

    //         let memo: any = graph && graph.getSelectedCells()[0]
    //         let name: any
    //         let _userInfo: any = StorageModule.getUser().user

    //         //console.log(taskType)
    //         let params: any = {
    //             memoId: memo.id,
    //             name: taskType.name,
    //         }

    //         //console.log(form.getFieldsValue().executorId)
    //         if (taskType.name == '任务计划' || taskType.name == '开始执行' || taskType.name == '任务完成') {
    //             if (taskType.name !== '任务计划') {
    //                 //值为当前操作人
    //                 params.executorId = userInfo?.id
    //             } else if (form.getFieldsValue().executorId != null) {
    //                 params.executorId = form.getFieldsValue().executorId
    //             }
    //             params.finishTime = (finishTime != '') ? moment(finishTime).format('YYYY-MM-DDT23:59:59') : form.getFieldsValue().finishTime.format('YYYY-MM-DDT23:59:59')
    //             params.manHour = form.getFieldsValue().manHour
    //             let res: any = await apis.putMemoNotation(memo.id, taskType.notation, params)
    //             if (res.ok) {
    //                 setTaskVisible(false)
    //             }
    //         }
    //         if (taskType.name == '图片格式') {

    //             let res: any = await apis.putMemoImageTag(memo.id, {
    //                 // id: memoId.current[0],
    //                 title: form.getFieldsValue().title,
    //                 imagePath: imgId
    //             })
    //             if (res.ok) {
    //                 setTaskVisible(false)
    //                 setIsDeletExecutor(false)
    //                 setImgId('')
    //             }
    //         }
    //         if (taskType.name == '图片标注') {
    //             //console.log(memo.id)
    //             let _annotation: any = []
    //             store.ImgNotesTag.map((i: any) => {
    //                 _annotation.push({
    //                     "x": i.x,
    //                     "y": i.y,
    //                     "w": i.w,
    //                     "h": i.h,
    //                     "description": i.description,
    //                 })
    //             })
    //             let res: any = await apis.putMemoImgNotesTag(memo.id, {
    //                 // id: memoId.current[0],
    //                 annotation: _annotation,
    //                 imagePath: imgId,
    //                 title: form.getFieldsValue().title,
    //             })
    //             if (res.ok && !imgNotesTagNextStep) {
    //                 setTaskVisible(false)
    //                 setIsDeletExecutor(false)
    //                 setImgId('')
    //             }
    //         }
    //         if (taskType.name == '版本计划') {
    //             let res: any = await apis.putMemoRelease(memo.id, {
    //                 // id: memoId.current[0],
    //                 memoId: memo.id,
    //                 release: form.getFieldsValue().release
    //             })
    //             if (res.ok) {
    //                 memoId.current.shift()
    //                 setTaskVisible(false)
    //                 setIsDeletExecutor(false)
    //             }
    //         }

    //     } catch (e) {
    //         //console.log(e)
    //     }
    // }

    /*
    * 创建子主题
    */
    const saveSonSubject = async (type?: any) => {
        try {
            let n_memoId: any = memoId.current
            let removeArr: any = []
            if (n_memoId.length < selectedCells.current.length + 2 + selectedEdgeCells.current.length) {
                //console.log('小于')
                getId()
                setTimeout(() => {
                    saveSonSubject(type)
                }, 200)
                return
            }

            let params: any = {
                $operate$: "save",
                id: memoId.current[0],
                memoId: memoId.current[1],
                subject: (selectedCells.current.length === 1) ? selectedCells.current[0].data.label : subjectTitle,
                memos: [],
                relationBelongTos: [],
                parentId: subjectData.current?.id,
                permissionType: subjeckPrivate ? 'PRIVATE' : 'OVERT'
            }
            if (type == 'one') {
                params.permissionType = 'OVERT'
            }
            //
            memoId.current.splice(0, 2)
            params = dealSelection(params)
            //console.log(params)
            // //console.log(JSON.stringify(params))
            let res: any = await apis.putCreatSonsubject(params.id, 'save', params)
            if (res.ok) {
                setAddThemeVisible(false)
                //移除便签
                removeNode('delete')
                setSubjeckPrivate(false)
            }
        } catch (e) {

        }
    }
    /**
       * 新建节点
       * $operate$ null 新建
       * copy复制
       */
    const createNode = (type: any, $operate$?: any) => {
        //
        menuCancel()
        console.log($operate$, txt, selectedCells.current[0], state.txtStr)

        let params: any = deepCopy(subjectData.current)
        //console.log('ss', params)
        params.$operate$ = 'save'

        //框选多个的情况
        let n_memoId: any = memoId.current
        if (n_memoId.length < selectedCells.current.length + selectedEdgeCells.current.length) {
            //console.log('小于')
            getId()
            setTimeout(() => {
                createNode(type, $operate$)
            }, 200)
            return
        }
        //增量传值，所以将memos、comments、relationBelongTos置空
        params.memos = []
        params.comments = []
        params.relationBelongTos = []
        if (!$operate$) {
            //新建
            //console.log('新建', selectedCells.current, diskMenuShow.prop().position)
            //console.log(mousePosition.current)
            if (type === 'memos' || type === 'comments') {
                params[type] = [{
                    $operate$: 'save',
                    ownerId: userInfo?.id,
                    content: ($operate$) ? selectedCells.current[0].data.label : state.txtStr,
                    id: memoId.current[0],
                    visible: true,
                    x: ($operate$) ? selectedCells.current[0].prop().position.x + Math.floor(Math.random() * 70 + 10) : mousePosition.current.x,
                    y: ($operate$) ? selectedCells.current[0].prop().position.y + Math.floor(Math.random() * 70 + 10) : mousePosition.current.y
                }]
                moveNums = -1
            } else if (type === 'relationBelongTos') {
                //console.log(selectedCells.current)
                params.relationBelongTos = [{
                    $operate$: 'save',
                    ownerId: userInfo?.id,
                    id: memoId.current[0],
                    visible: true,
                    superId: selectedCells.current[1].id,
                    suborId: selectedCells.current[0].id,
                    content: ""
                }]
            }
            memoId.current.shift()
            saveSubject(params)
            return
        } else {
            //console.log('复制', subjectData.current)
            params = dealSelection(params, 'copy')
        }
        //memoId.current.splice(0, selectedCells.current.length + len)
        memoId.current = []
        //console.log('复制====', params)
        saveSubject(params)

    }
    //type==copy 说明是复制。节点id要变，新建子主题 节点id则不变。
    const dealSelection = (params: any, type?: any) => {
        let len = 0
        const nums: any = selectedEdgeCells.current.length + selectedCells.current.length
        let selecedAdll: any = selectedCells.current.concat(selectedEdgeCells.current)
        if (memoId.current.length < nums) {
            const idsNums: Number = Math.floor((nums - memoId.current.length) / 5) + 1
            for (let i: any = 0; i < idsNums; i++) {
                getId()
            }
        }
        let data: any = []
        let copyIds: any = {}
        selecedAdll.map((i: any, index: any) => {
            copyIds = {
                ...copyIds, ...{
                    [i.id]: memoId.current[index]
                }
            }
            if (i.data.type === 'relationBelongTos') {
                //console.log('relationBelongTos', i)
                data.push({
                    $operate$: 'save',
                    ownerId: userInfo?.id,
                    id: (type === 'copy') ? memoId.current[index] : i.id,
                    visible: true,
                    "superId": i.target.cell,
                    "suborId": i.source.cell,
                    content: i.data.label
                })

                len += index

            } else {
                let _tagMetas: any = []
                console.log(i)
                i.data?.data?.tagMetas?.map((j: any, jndex: any) => {
                    if (j.mimeType == "text/markdown") {
                        // console.log('j=1', j)
                        _tagMetas.push({
                            // ...j,
                            name: j.name,
                            notation: j.notation,
                            type: j.type,
                            instance: {
                                ...j.instance,
                                content: i.data?.data?.content,
                            }
                        })
                    } else {
                        _tagMetas.push({
                            ...j,
                            content: i.data?.data?.label,
                            name: j.name,
                            notation: j.notation,
                            type: j.type,
                            instance: {
                                ...j.instance,
                                // imagePath: i.instance.imagePath,
                                // // memoId: i.instance.memoId,
                                // annotation: i.instance.annotation
                            }
                        })
                    }
                    delete _tagMetas[jndex].instance.id
                    delete _tagMetas[jndex].instance.memoId
                })
                params[i.data.type].push({
                    $operate$: 'save',
                    ownerId: userInfo?.id,
                    content: i.data.label,
                    id: (type === 'copy') ? memoId.current[index] : i.id,
                    mimeType: i.data.data.mimeType,
                    tagMetas: _tagMetas,
                    visible: true,
                    x: i.prop().position.x + Math.floor(Math.random() * 70 + 10),
                    y: i.prop().position.y + Math.floor(Math.random() * 70 + 10)
                })
            }

        })
        //如果是copy则相关id都取新值放到参数params里，如果不是则还使用原来的id
        if ((type === 'copy')) {
            data.map((item: any, id: any) => {

                let _data = {
                    ...item, ...{
                        id: memoId.current[selectedCells.current.length + id],
                        superId: copyIds[item.superId],
                        suborId: copyIds[item.suborId],
                        suborMemo: params.memos.filter((obj: any) => obj.id == copyIds[item.suborId])[0],
                        superMemo: params.memos.filter((obj: any) => obj.id == copyIds[item.superId])[0],
                    }
                }
                params.relationBelongTos.push(_data)
                len += id + 1
            })
        } else {
            params.relationBelongTos = data
        }
        return params
    }
    /***
     * 
     * 显示隐藏项
     */
    const showNodeVisible = (type: any, node?: any) => {
        menuCancel()
        if (!subjectData.current) return
        if (node) {
            node.setData({ ...node.data, isShow: type })

        }
        //console.log('selectedArr===', subjectData, node)
        let params: any = deepCopy(subjectData.current)
        params.$operate$ = 'save'
        let selectedArr: any = []
        params.memos && params.memos.map((i: any, id: Number) => {
            if (!i.visible) {
                if (type) {
                    graphAddNodeMemo(graph, i)
                    graph.getCellById(i.id) && graph.getCellById(i.id).prop('data/recoverVisible', true)
                    selectedArr.push(i)
                    graph.select(graph.getCellById(i.id))
                } else {
                    graph.removeCells([i.id])
                }
            }
        })


        params.comments && params.comments.map((i: any) => {
            if (!i.visible) {
                if (type) {
                    graphAddNodeComment(graph, i)
                    graph.getCellById(i.id) && graph.getCellById(i.id).prop('data/recoverVisible', true)
                } else {
                    graph.removeCells([i.id])
                }
            }
        })


        setTimeout(() => {

            params.relationBelongTos && params.relationBelongTos.map((i: any) => {
                //console.log('i', i)
                if (!i.visible) {
                    if (type) {
                        graphAddEdge(graph, i)
                        //console.log(i)
                        graph.getCellById(i.id) && graph.getCellById(i.id).prop('data/recoverVisible', true)
                        if (i.content !== '') {
                            graph.getCellById(i.id).appendLabel(i.content)
                        }
                    } else {
                        graph.removeEdge(i.id)
                    }

                }

            })

        }, 500);

        dealHide(null, 'menu',)

    }
    /***
     * 
     * 隐藏节点
     */
    const nodeVisible = (type: any, node: any, visible?: any) => {
        let params: any = deepCopy(subjectData.current)
        params.$operate$ = 'save'
        // if (selectedCells.current.length > 0) {
        let arr: any = []
        //console.log(selectedCells.current, params)
        params.comments = []
        params.memos = []
        params.relationBelongTos = []
        selectedCells.current.map((i: any, index: any) => {
            // if (i.data.type === 'memos') {
            i.setData({ ...i.data, recoverVisible: (visible) ? false : true })
            params[i.data.type].push({ ...i.data.data, visible: (visible) ? true : false })
            arr.push(i.id)
            subjectData.current.relationBelongTos.map((j: any) => {
                //console.log(j)
                if (i.id === j.suborId || i.id === j.superId) {
                    params.relationBelongTos.push({ ...j, visible: (visible) ? true : false })
                    //console.log(graph.getCellById(j.id))
                    graph.getCellById(j.id).prop('data/recoverVisible', (visible) ? false : true)
                }
            })

        })


        //console.log(graph.getCells())
        if (!visible) {
            setTimeout(() => {
                graph.removeCells(arr)
            }, 500)
        }
        saveSubject(params, node)
    }
    /**
     * 节点变化
    */
    const nodeChanged = () => {
        graph.on("node:changed", ({ node, options }: { node: any, options: any }) => {
            // console.log("node:changed")
            node.stopPropagation = true
            //修改便签内容
            if (JSON.stringify(options) !== '{}' && options.propertyPath === 'attrs/text/text') {
                editNode(node.id, options.propertyValue)
            }
        });
        //获得拖拽进入群组的节点
        graph.on('node:change:parent', ({ node }: { node: any, }) => {
            console.log('node:change:parent', node)
            if (node.data.init) return
            //判断是移出群组还是意如群组，如果被移动的节点shape == 'group-node'，则说明是群组内节点
            if (node.shape == 'group-node') {
                //移出群组
                console.log("移出群组")
                isGroupAdd = false
            } else {
                // if (node.parent && !node.data.data.init) {
                //     console.log("不允许移动到其他群组")
                //     // return
                // }
                console.log("移入群组")
                //移入群组
                isGroupAdd = true
            }
        })
        //获得拖拽进入群组的群组信息
        graph.on('node:change:children', ({ node, current, previous }: { node: any, current: any, previous: any }) => {
            console.log('node:change:children', isGroupAdd, node)
            if (node.data.init) return
            if (selectedCells.current.length == 0 || node.shape == 'group-node') return
            console.log(selectedCells.current)
            if (isGroupAdd == true) {
                editGroup(node, 'save')

                removeNode('group')
                setTimeout(() => {
                    updateGroupNode(node)
                }, 1000);
            } else {

                // removeNode('group')
                console.log(selectedCells.current)
                let params: any = deepCopy(subjectData.current)
                params.$operate$ = 'save'
                params.comments = []
                params.memos = []
                params.relationBelongTos = []
                let _tagMetas: any = []
                selectedCells.current[0].data?.data?.tagMetas?.map((i: any, index: any) => {
                    _tagMetas.push({
                        ...i,
                        name: i.name,
                        notation: i.notation,
                        type: i.type,
                        instance: {
                            ...i.instance,
                            // imagePath: i.instance.imagePath,
                            // // memoId: i.instance.memoId,
                            // annotation: i.instance.annotation
                        }
                    })
                    delete _tagMetas[index].instance.id
                    delete _tagMetas[index].instance.memoId
                })
                let _id: any = selectedCells.current[0].id
                // console.log(selectedCells.current[0].id, _id,_id.indexOf('_'))
                _id = _id.substring(_id.indexOf('_') + 1, _id.length)
                console.log('_id', _id)
                // return
                params.memos = [{
                    $operate$: 'save',
                    mimeType: selectedCells.current[0].data.data.mimeType,
                    tagMetas: _tagMetas,
                    ownerId: userInfo?.id,
                    content: selectedCells.current[0].data.label,
                    id: _id,
                    visible: true,
                    x: selectedCells.current[0].prop().position.x,
                    y: selectedCells.current[0].prop().position.y,
                    topicIds: [],
                    topicNames: null
                }]
                console.log(params)
                // memoId.current.shift()
                graph.removeCells([selectedCells.current[0].id])
                saveSubject(params)
                editGroup(node, 'remove')

            }
            selectedCells.current = []

        })
    }
    const editGroup = (node: any, type: any) => {
        setModalBoxShow(true)
        let params: any = deepCopy(node?.data?.data)
        params.$operate$ = 'save'
        // if (selectedCells.current.length > 0 && type == 'memos') {
        let arr: any = []
        //增量传值，所以将memos、comments、relationBelongTos置空
        params.memos = []
        params.comments = []
        params.relationBelongTos = []
        params.memoId = node?.data?.data?.memoId
        console.log('editGroup', type)
        let dataVal: any = []
        let relationBelongTos: any = []
        console.log('selectedCells.current', selectedCells.current)

        selectedCells.current.map((i: any, index: any) => {
            let _tagMetas: any = []
            i.data?.data?.tagMetas?.map((j: any, jndex: any) => {
                _tagMetas.push({
                    ...j,
                    name: j.name,
                    notation: j.notation,
                    type: j.type,
                    instance: {
                        ...j.instance,
                        // imagePath: i.instance.imagePath,
                        // // memoId: i.instance.memoId,
                        // annotation: i.instance.annotation
                    }
                })
                delete _tagMetas[jndex].instance.id
                delete _tagMetas[jndex].instance.memoId
            })
            if (i.data.type === 'group' || i.data.type === 'memos') {
                dataVal.push({ ...i.data.data, $operate$: type, })
                if (type == 'save') {
                    console.log('dataVal[index].id', dataVal[index].id)
                    dataVal[index].tagMetas = _tagMetas
                    // memoId.current.shift()
                }
                // params.relationBelongTos.map((j: any) => {
                //     if (i.id === j.suborId || i.id === j.superId) {
                //         arr.push(i.id)
                //         relationBelongTos.push({ ...j, $operate$: type })
                //     }
                // })
            }
        })
        params.memos = dataVal
        // params.relationBelongTos = relationBelongTos.filter(function (item: any, index: any, self: any) {
        //     return self.findIndex((el: any) => (el.id == item.id) && item.visible) === index
        // })
        isGroup = true
        saveGroupSubject(params, node, type)
        // if (type == 'delete') {
        //     graph.getCellById(node.id).size(120, graph.getCellById(node.id).size().height - 25)
        // }
    }
    /***
     * 修改便签内容
     */
    const editNode = async (id: any, content: any) => {
        try {
            let res: any = await apis.putMemo(id, { content: content })
        } catch (e) { }
    }
    /***
     * 移动节点后触发
     */
    // node:moved
    const nodeMoved = () => {
        try {
            graph.on("cell:moved", ({ e, x, y, cell, view }: { e: any, x: any, y: any, cell: any, view: any }) => {
                //console.log('cell:moved',)

            });
            graph.on('node:moved', async ({ node, x, y, }: { node: any, x: any, y: any, }) => {
                console.log('node:moved', isGroup, node,)

                //console.log(node.data.type)
                if (isGroup) {
                    let _id: any = node.id
                    setTimeout(() => {
                        isGroup = false
                        _id = _id.substring(_id.indexOf('_') + 1, _id.length)
                        console.log('_id', _id, graph.getCellById(_id), node.id)
                        //群组A拖到群组B时在node:change:children里删除失效。在这里再删除一次
                        if (graph.getCellById(_id) && node.shape == 'group-node') {
                            graph.removeCells([node.id])
                        }
                    }, 500);
                    return
                } else {

                }
                if (node.shape == 'group') return
                if (node.data.type !== 'menu' && node.id !== 'diskMenu') {
                    moveNums++
                    if (selectedCells.current.length == 0) {
                        moveNums = 0
                    }
                    //console.log(moveNums , selectedCells.current.length)
                    graph.enablePanning()
                    if (moveNums == selectedCells.current.length && selectedCells.current.length != 0) {
                        let params: any = deepCopy(subjectData.current)
                        let node: any = selectedCells.current[0]
                        params.$operate$ = 'save'
                        if (params[node.data.type]) {
                            //记住第一个移动对象的初始位置，用初始位置算出移动距离
                            let mark: any = params[node.data.type].filter((i: any) => i.id === node.id)[0]
                            let mark_pos: any = {
                                x: node.prop().position.x - mark.x,
                                y: node.prop().position.y - mark.y
                            }
                            //增量传值，所以将memos、comments、relationBelongTos置空
                            params.memos = []
                            params.comments = []
                            params.relationBelongTos = []

                            if (selectedCells.current.length > 1) {

                                let dataVal: any = []
                                selectedCells.current.map((j: any) => {
                                    let data = j.data.data
                                    dataVal.push({
                                        ...data, x: data.x + mark_pos.x,
                                        y: data.y + mark_pos.y
                                    })
                                })

                                params[node.data.type] = dataVal
                            } else {
                                params[node.data.type] = [{
                                    ...node.data.data,
                                    x: node.prop().position.x,
                                    y: node.prop().position.y
                                }]
                            }
                            saveSubject(params)
                        }
                    }

                } else {
                    node.stopPropagation = true
                    //当拖拽taskmenu时，停止画布拖拽
                    graph.disablePanning()
                }

            })

            graph.on('blank:mousedown', async ({ node, x, y, }: { node: any, x: any, y: any, }) => {
                //console.log('blank:click', node)
                dealHide(null, 'menu', node)
            })
            graph.on('node:move', async ({ node, x, y, }: { node: any, x: any, y: any, }) => {
                console.log('node:move')
                if (node.shape != 'group-node' && node.shape != 'group') {
                    // 先判断移动目标是否是框选对象内的，是则继续操作，否 则取消框选，选中当前目标
                    let isCurrent: any = []
                    isCurrent = graph.isSelected(node.id)
                    if (!isCurrent) {
                        //取消框选
                        graph.resetSelection()
                        graph.select(node)
                    }
                    node.toFront()
                } else {

                }
            })
            graph.on('node:mouseleave', async ({ node, x, y, }: { node: any, x: any, y: any, }) => {
                // //console.log('node:mouseleave')
            })
        } catch (e) { }
    }
    //type== delete 代表建子主题时删除的节点。后台要处理孤立便签所以加了操作参数
    const removeNode = async (type?: any) => {

        let params: any = deepCopy(subjectData.current)
        params.$operate$ = 'save'
        // if (selectedCells.current.length > 0 && type == 'memos') {
        let arr: any = []
        //增量传值，所以将memos、comments、relationBelongTos置空
        params.memos = []
        params.comments = []
        // params.relationBelongTos = []
        //console.log(selectedCells.current)
        let dataVal: any = []
        let relationBelongTos: any = []

        selectedCells.current.map((i: any, index: any) => {
            if (i.data.type === 'memos') {
                arr.push(i.id)
                dataVal.push({ ...i.data.data, $operate$: (type === 'group') ? 'remove' : 'delete' })
                params.relationBelongTos.map((j: any) => {
                    if (i.id === j.suborId || i.id === j.superId) {
                        arr.push(i.id)
                        relationBelongTos.push({ ...j, $operate$: 'delete' })
                    }
                })
            }
        })
        console.log('dataVal', dataVal)
        setTimeout(() => {
            graph.removeCells(arr)
        }, 500)
        params.memos = dataVal
        params.relationBelongTos = relationBelongTos.filter(function (item: any, index: any, self: any) {
            return self.findIndex((el: any) => (el.id == item.id) && item.visible) === index
        })
        if (type === 'delete') {
            await apis.putCreatSonsubject(params.id, 'delete', params)
        } else if (type === 'group') {
            graph.removeCells([selectedCells.current[0].id])
            saveSubject(params)
        } else {
            saveSubject(params)
        }
    }
    /**
       * 新建节点
       */
    const deleteNode = async (type: any) => {
        try {

            if (type === 'memos') {
                //console.log('删memos', cNode.current.id, subjectData.current)
                let res: any = await apis.deleteMemo(cNode.current.id)
                if (res.ok) {
                    graph.removeCells([cNode.current.id])
                    // getDetail(subjectData.current?.id)
                }

            } else if (type === 'relationBelongTos') {
                //console.log('删relationBelongTos')
                let res: any = await apis.deleteBelong(cNode.current.id)
                if (res.ok) {
                    //console.log(graph.getCells())
                    graph.removeCells([cNode.current.id])
                    //console.log(graph.getCells())

                    // getDetail(subjectData.current?.id)
                }
            } else if (type === 'comments') {
                //console.log('删注释1')

                let params: any = deepCopy(subjectData.current)
                params.$operate$ = 'save'
                params.relationBelongTos = []
                params.memos = []
                params.comments = []
                // params.comments = [{ ...cNode.current.data.data, $operate$: 'delete' }]
                //console.log(selectedCells.current)
                selectedCells.current.map((i: any, index: any) => {
                    params.comments.push({ ...i.data.data, $operate$: 'delete' })
                })
                // params.comments.map((i: any) => {
                //     if (i.id === cNode.current.id) {
                //         i.$operate$ = 'delete'
                //     }
                // })
                // graph.removeCells([cNode.current.id])
                saveSubject(params)
            }
            // }
            // setTimeout(() => {
            //     getDetail(subjectData.current?.id)
            // }, 1000);
        } catch (e) {

        }
    }
    //删除当前监听
    const onDeleteListener = async (id: any) => {
        try {
            let res: any = await apis.deleteListener(id)
        } catch (e) { }
    }
    /**
     * 双击编辑节点
     */
    const nodeDbClick = () => {
        graph.on('node:dblclick', ({ node, e }: { node: any, e: any }) => {
            console.log('node:dblclick', node)
            // 点击图标直接不处理
            if ((e.target.hasOwnProperty('className') && e.target.className.indexOf('chaticon') > -1) || node.shape == 'group-node') {
                return null;
            }
            //双击群组进入群组相应主题
            if (node.shape == 'group') {
                onDeleteListener(store.subjectInfo.subjectId)
                let _id = node.id
                _id = _id.substring(6, _id.length)
                getDetail(_id)
                window.location.hash = '#/view'
                return
            }
            //解散讨论后，非本用户创建的便签只能操作隐藏、移动、移除
            let isOwner = (userInfo?.id === node.data.data.ownerId) ? true : false
            let isHasDiscuss = (subjectData.current?.users?.length == 0 && !isOwner) ? false : true
            setOperationType((node.shape === 'comment-node') ? 'comments' : "memos")
            setIsAdd(false)
            if ((node.shape === 'memo-node' || node.shape === 'memo-node') && !isHasDiscuss) {
                setMemoModal(false)
                message.warning('当前无共享成员，只能操作自己的markdown格式/图片格式/图片标注类型的便签')
            } else {
                const { mimeType } = node.data.data

                labelPop(mimeType, node)
            }
            setTxt(node.data.label)
            state.txtStr = node.data.label
            setState(state)
            dealHide(null, 'menu', node)
            setCNode(node)
            node.toFront()
        })
        graph.on('node:mouseleave', ({ node, e, x, y }: { node: any, e: any, x: any, y: any }) => {
            console.log('node:mouseleave')
            // menuCancel()
        })
        graph.on('edge:dblclick', ({ edge, e }: { edge: any, e: any }) => {
            console.log('edge:dblclick', edge)
            //解散讨论后，非本用户创建的便签只能操作隐藏、移动、移除
            let isOwner = (userInfo?.id === edge.data.data.ownerId) ? true : false
            let isHasDiscuss = (subjectData.current?.users?.length == 0 && !isOwner) ? false : true
            if (edge.shape === 'edge' && !isHasDiscuss) {
                setMemoModal(false)
                message.warning('当前无共享成员，只能操作自己的markdown格式/图片格式/图片标注类型的便签')
                return
            }
            clearTimeout(timer);
            setOperationType('relationBelongTos')
            setIsAdd(false)
            setTxt(edge.data.data.content)
            state.txtStr = edge.data.data.content
            setState(state)
            dealHide(null, 'menu', edge)
            setCNode(edge)
            setMemoModal(true, 'relationBelongTos', false)
        })

    }
    /**
     * 隐藏菜单和编辑框,或只允许一个菜单留着界面
     */
    const dealHide = (id: any, type?: any, node?: any) => {
        menuCancel()
        if (node) {
            // if (node.shape === 'memo-node') {
            //     node.size(120, 120);
            // }
        } else {
            //console.log(selectedCells.current)
            if (selectedCells.current[0]?.shape === 'memo-node') {
                // selectedCells.current[0].size && selectedCells.current[0].size(120, 120);
            }
        }

        graph.getCells().length > 0 && graph.getCells().map((i: any) => {
            if (type === 'menu') {
                i.setData({ ...i.data, menuShow: (i.id === id) ? true : false })
                i.setData({ ...i.data, isEdit: false, isMore: false, isActive: false })
            } else if (type === 'edit') {
                i.setData({ ...i.data, isEdit: (i.id === id) ? true : false })
                i.setData({ ...i.data, menuShow: false, isMore: false })
            } else {
                i.setData({ ...i.data, menuShow: false, isEdit: false, isMore: false, isActive: false })
            }
        })

    }
    /**
     * 操作节点节点
     */
    const nodeContextmenu = () => {

        graph.on('node:contextmenu', ({ node, e, x, y }: { node: any, e: any, x: any, y: any }) => {

            console.log('node:contextmenu', node)
            //解决 连续右击不同便签会选中便签 ，判断选中目标是否已被框选，是则无动作，否则清除选区
            let isSelected: any = graph.isSelected(node.id)
            node.toFront()
            if (node?.shape == "group") {
                //将群组的children也置顶
                node.children.map((i: any) => {
                    i.toFront()
                })
            }
            if (isSelected) {
                graph.select(node)
            } else {
                graph.resetSelection(node)
            }
            //console.log(selectedCells.current)

            dealChechk(node)
            dealHide(node.id, 'menu', node)
        })
    }
    const setMemoModal = (e: any, _operationType?: any, _isAdd?: any) => {
        if (_isAdd) {
            dispatch({
                type: 'SET_CNODE',
                data: null
            });
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { content: "", data: {} }
            });
            dispatch({
                type: 'SET_MEMOINFO',
                data: { content: "", data: {} }
            });
        }
        console.log('OperationType', operationType, isAdd)
        console.log('OperationType1', e, _operationType, _isAdd)
        dispatch({
            type: 'SET_MEMOMODAL',
            data: {
                visible: e,
                operationType: _operationType || '',
                isAdd: _isAdd || false
            }
        });

        // if (e) {
        //     dispatch({
        //         type: 'SET_CNODE',
        //         data: { mimeType: null }
        //     });
        //     // setTagVisible(true)
        // }
        menuCancel()
    }
    const setCNode = (node: any) => {
        if (node?.data?.type !== 'menu' || !node) {
            cNode.current = node

            dispatch({
                type: 'SET_CNODE',
                data: (node) ? node.data.data : null
            });
        }
        if (node) {
            dispatch({
                type: 'SET_MEMOINFO',
                data: node.data
            });
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: node.data
            });
        }
    }

    /**
        * 监听页面空白处，点击右键，出现出现菜单，
        * 根据点击处更新坐标位置
        */
    const blankContextmenu = () => {
        graph.on('blank:contextmenu', ({ e, x, y, }: { e: any, x: any, y: any, }) => {
            //console.log('blank:contextmenu', x, y,)
            dealEdgeStyle(null)
            dealHide(null, 'menu', null)

            mousePosition.current = { x: x, y: y }
            dispatch({
                type: 'SET_MOUSEPOSITION',
                data: { x: x, y: y }
            });
            //console.log(diskMenuShow.prop().position)
            // diskMenuShow.show()
            diskMenuAdd()
            diskMenuShow.prop("position", { x: x, y: y })
            diskMenuShow.toFront()
            // relationMenuShow.current = false
            selectedCells.current = []
            dispatch({
                type: 'SET_MEMOS_NUM',
                data: graph.getSelectedCells().length
            });
            graph.cleanSelection()
        })
        graph.on('blank:click', ({ e, x, y, }: { e: any, x: any, y: any, }) => {
            //console.log('blank:click',)
            dealEdgeStyle(null)
            dealHide(null, 'menu', null)
            selectedCells.current = []
            dispatch({
                type: 'SET_MEMOS_NUM',
                data: graph.getSelectedCells().length
            });

        })

    }
    /**
        * 统一处理选中边样式
        */
    const dealEdgeStyle = (id: any, edge?: any) => {
        graph.getEdges().map((i: any) => {
            if (i.id === id) {
                i.attr("line/strokeDasharray", 0)
                i.attr("line/stroke", '#faad14')
            } else {
                i.attr("line/strokeDasharray", 0)
                i.attr("line/stroke", '#567AEF')
            }
        })
        if (edge) {
            selectedCells.current = [edge]
        }
    }
    /**
                    * 监听点击节点
                    * 根据点击处更新坐标位置
                    */
    const nodeClick = () => {
        graph.on('node:click', ({ e, x, y, node, view }: { e: any, x: any, y: any, node: any, view: any }) => {
            //console.log('node:click', node)
            if (node.shape != 'group-node' && node.shape != 'group') {
                if (!node.data.isEdit) {
                    //setTimeout解决为什么，不知为啥点击关系菜单项目不生效
                    setTimeout(() => {
                        dealHide(null, 'menu', node)
                    }, 500);
                }
                node.toFront()
                dealChechk(node)
            } else { }
        })
        // graph.on('edge:click', ({ e, x, y, edge, view }: { e: any, x: any, y: any, edge: any, view: any }) => {
        //     //console.log('edge:click', edge)
        //     clickDisabled = clickDisabled + 1
        //     //console.log(clickDisabled)
        //     clearTimeout(timer);
        //     timer = setTimeout(() => {
        //         if ((edge.data.data.content.length > setLablesNum) && clickDisabled == 1) {
        //             getConvertHtml(edge?.data)
        //         }
        //     }, 200);
        // })
        // graph.setSelectionFilter(['memo-node','edge'])
        //禁止框选区移动
        graph.disableSelectionMovable()
        graph.on("edge:selected", ({ edge, e }: { edge: any, e: any }) => {
            //console.log("edge:selected", edge);
            dealEdgeStyle(edge.id, edge)
        })
        graph.on("edge:mouseenter", ({ edge, e }: { edge: any, e: any }) => {
            //console.log("edge:mouseenter", edge);
            edge.attr("line/strokeDasharray", 5)
        })
        graph.on("edge:mouseleave", ({ edge, e }: { edge: any, e: any }) => {
            // //console.log("edge:mouseleave", edge);
            edge.attr("line/strokeDasharray", 0)
        })
        graph.on('edge:contextmenu', ({ e, x, y, edge, view }: { e: any, x: any, y: any, edge: any, view: any }) => {
            //console.log('edge:contextmenu', edge)
            setCNode(edge)
            dealHide(edge.id, 'menu', edge)
            menuCancel()
            dealEdgeStyle(edge.id, edge)
            dealEdgeMenu()
            edgeMenuShow.prop("position", { x: x, y: y })
            edgeMenuShow.show()
            edgeMenuShow.toFront()

            // cEdge.current = edge
        })
        graph.on("node:selected", ({ node, e }: { node: any, e: any }) => {
            console.log("node:selected", node, graph.getSelectedCells(), selectedCells.current);
            dispatch({
                type: 'SET_PING_MEMO',
                data: {}
            });
            //不允许框选菜单
            graph.unselect(['diskMenu', 'edgeMenu'])
            // graph.setSelectionFilter(['memo-node'])
            relationMenuShow.current = true
            // e.target.checked ? ['circle'] : undefined,
            //获取圈选的值
            if (node.id !== 'edgeMenu' && node.id !== 'diskMenu') {
                selectedCells.current = graph.getSelectedCells()
                dispatch({
                    type: 'SET_MEMOINFO',
                    data: graph.getSelectedCells()[0].data
                });
                dispatch({
                    type: 'SET_MEMOS_NUM',
                    data: graph.getSelectedCells().length
                });
                dealHide(null, null, node)
                /**
                 * 处理边的选中
                 */
                /**
                 * 当选中节点大于两个时，才会选中边 。并且只有当上级节点，下级节点都被框选中后，边才会被选中
                 */
                graph.getEdges().map((i: any) => {
                    i.attr("line/strokeDasharray", 0)
                    i.attr("line/stroke", '#567AEF')
                })
                selectedEdgeCells.current = []
                if (graph.getSelectedCells().length > 1) {
                    let edgeArr: any = []
                    //console.log(subjectData.current)
                    subjectData.current && subjectData.current.hasOwnProperty('relationBelongTos') && subjectData.current.relationBelongTos.map((i: any) => {
                        let allNode: any = graph.getSelectedCells()
                        let edge: any = graph.getCellById(i.id)
                        if (allNode.find((j: any) => j.id == i.suborId) && allNode.find((j: any) => j.id == i.superId) && edge) {
                            edge.attr("line/strokeDasharray", 0)
                            edge.attr("line/stroke", '#faad14')
                            edgeArr.push(edge)
                        }
                    })
                    selectedEdgeCells.current = edgeArr
                    //console.log('selectedEdgeCells', edgeArr)
                } else {

                }
            }
        });


    }
    const dealChechk = (node: any) => {
        let new_nodeArr: any = nodeArr
        console.log('dealChechk',)
        if (node.data.type === 'memos') {


        } else if (node.data.type === 'comments') {
            //console.log('?', node)

            // graph.getNodes().length > 0 && graph.getNodes().map((i: any) => {
            //     if (i.shape === 'comment-node') {
            //         i.setData({ ...i.data, isActive: false })

            //     }
            // })
            // node.setData({ ...node.data, isActive: true })
        }
        if (node.id !== 'edgeMenu' && node.id !== 'diskMenu') {
            //console.log("lll???")
            setCNode(node)
        }
        //console.log(node, selectedCells.current, selectedCells.current.length)
        //若选中的是注释节点，则使selectedCells等于注释节点
        if (selectedCells.current.length === 0 || (node.shape === 'comment-node' && selectedCells.current.length === 1)) {
            //console.log('???')
            selectedCells.current = [node]
            //console.log(selectedCells.current)
        }
    }
    /**
        * 创建菜单节点，初始化隐藏
        */
    const menuInit = () => {
        diskMenuShow = graph.addNode({
            ...diskMenu,
            data: {
                isShow: store.showNode
            }
        })
        edgeMenuShow = graph.addNode({
            ...edgeMenu
        })
        // menuCancel()
    }
    const diskMenuAdd = () => {
        console.log('diskMenuAdd')
        diskMenuShow = graph.addNode({
            ...diskMenu,
            data: {
                isShow: store.showNode
            }
        })

    }
    const edgeMenuAdd = () => {
        edgeMenuShow = graph.addNode({
            ...edgeMenu
        })
    }
    const dealEdgeMenu = () => {
        //防止公共状态凝固，删除菜单，重新渲染
        graph.removeCells(['edgeMenu'])
        edgeMenuShow = graph.addNode({
            ...edgeMenu
        })
    }
    /**
     * 
     * 操作节点事件后
     * 隐藏各类型菜单
     */
    const menuCancel = () => {
        console.log('隐藏菜单')
        // diskMenuShow.hide()
        graph.removeCells(['diskMenu'])
        graph.removeCells(['edgeMenu'])
        // edgeMenuShow.hide()
    }


    /**
     * 初始化网格
     */
    const graphInit = () => {
        console.log('初始化', graph)
        //记录画布中心点
        localStorage.setItem('things_x6_container', JSON.stringify({
            x: Math.floor(container.offsetWidth / 2 - 60),
            y: Math.floor(container.offsetHeight / 2 - 60)
        }))
        graph = (new Graph({
            // grid: {
            //     size: 50,      // 网格大小 10px
            //     visible: true, // 绘制网格，默认绘制 dot 类型网格
            // },
            // async:true,
            container: container,
            width: container.offsetWidth,
            height: container.offsetHeight,
            panning: {
                enabled: true,
                // modifiers: ['ctrl', 'meta'],
            },
            mousewheel: {
                enabled: true,
                modifiers: ['ctrl', 'meta'],
            },
            embedding: {
                enabled: true,
                findParent({ node }) {
                    if (node.shape == 'group') {
                        // console.log("移动的是群组")
                        return []
                    }
                    if (node.data.init) {
                        console.log('findParent', node)
                        //用init来判断是否是初始化，初始话的情况下，不允许进行群组节点接口操作
                        node.data.init = false
                        selectedCells.current = [node]
                    }
                    // 获取移动节点的包围盒
                    const bbox = node.getBBox()
                    // 找到 data 中配置 { parent: true } 的节点，并且移动节点和找到的节点包围盒相交时，返回 true
                    return this.getNodes().filter((node) => {
                        const data = node.getData<{ parent: boolean }>()
                        // console.log("data.parent", data)
                        if (data && data.parent) {
                            const targetBBox = node.getBBox()
                            // if (bbox.isIntersectWithRect(targetBBox)) {
                            // console.log("targetBBox", bbox.isIntersectWithRect(targetBBox), node.data.label)
                            // }
                            return bbox.isIntersectWithRect(targetBBox)
                        }
                        return false
                    })
                },
            },
            autoResize: true,
            //disableMove，禁止指定节点移动
            interacting: function (cellView) {
                // console.log(cellView.cell.getData())
                let _permissions = store.subjectInfo?.data?.permissions || []
                // if (cellView.cell.getData() != undefined && !cellView.cell.getData().disableMove) {
                //     console.log("-aa?")
                //     return { nodeMovable: false }
                // }
                if (cellView.cell.getData().hasOwnProperty('disableMove')) {
                    console.log("-bb?")
                    return { nodeMovable: cellView.cell.getData().disableMove }
                }
                //权限管理
                let isMemo_move = _permissions.some((i: any) => i == 'memo_move')
                let isComment_move = _permissions.some((i: any) => i == 'comment_move')
                console.log('isMemo_move', isMemo_move, 'isComment_move', isComment_move)
                console.log('_permissions', _permissions)
                if (cellView.cell.getData().type == 'memos' && !isMemo_move) {
                    return { nodeMovable: false }
                }
                if (cellView.cell.getData().type == 'comments' && !isComment_move) {
                    return { nodeMovable: false }
                }
                return true
            },
            //注册关系节点
            onEdgeLabelRendered: (args) => {
                const { selectors, edge } = args
                const str = edge.data.data.content
                const content = selectors.foContent as HTMLDivElement
                console.log("args,content", args, content)
                if (content) {
                    const _div = document.createElement('div')
                    const btn = document.createElement('div')
                    _div.appendChild(btn)
                    _div.style.width = '100%'
                    // _div.style.height = '100%'
                    _div.style.display = 'flex'
                    _div.style.justifyContent = 'center'
                    // _div.style.flexDirection = 'column'

                    if (str.length > 32) {
                        btn.appendChild(document.createTextNode(str))
                        _div.style.height = '100%'
                        btn.style.overflow = 'scroll'
                        // btn.appendChild(document.createTextNode(str.substring(0, 30) + '...'))
                        // const omit = document.createElement('div')
                        // omit.appendChild(document.createTextNode("..."))
                        // omit.style.textAlign = 'center'
                        // omit.style.background = '#fff'
                        // omit.style.fontWeight = 'bold'
                        // omit.addEventListener('click', () => {
                        //     // alert('clicked')
                        // })
                        // _div.appendChild(omit)

                    } else {
                        btn.appendChild(document.createTextNode(str))
                    }
                    // btn.style.width = '100%'
                    // btn.style.height = '100%'
                    btn.style.textAlign = 'left'
                    btn.style.color = '#000'
                    btn.style.background = '#fff'
                    btn.addEventListener('contextmenu', function (e) {
                        // e.preventDefault();
                        // alert('clicked')
                    })
                    console.log(graph.getCellById(edge.id).getLabelAt())
                    btn.addEventListener('click', () => {
                        // alert('clicked')
                    })
                    // btn.innerHTML = "<div>1</div>";
                    content.appendChild(_div)
                }
            },
        }));
        // 全局共享
        (window as any).graphItem = graph;

        // graph.zoom(0);
        // graph.centerContent();
        graph.use(
            new Clipboard({
                enabled: true,
            }),
        );

        graph.use(
            new Selection({
                enabled: true,
                movable: true,
                multiple: true,
                rubberband: true,
                className: style.active,
                showNodeSelectionBox: true,
                pointerEvents: 'none',
                // filter: ['diskMenu', 'edgeMenu'],
                modifiers: ['ctrl', 'meta'],
            })
        );
        graph.use(
            new Transform({
                resizing: {
                    enabled: true,
                    minWidth: 120,
                    maxWidth: 300,
                    minHeight: 120,
                    maxHeight: 300,
                    orthogonal: false,
                    preserveAspectRatio: false,
                },
            })
        );
        graph.use(
            new Keyboard({
                enabled: true,
                // global: true,
                // format(key) {
                //     //将command功能等同于ctrl
                //     return key.replace(/\s/g, "").replace("ctrl", "command");
                // },
            })
        );
        minimapViewChange()
    }
    const minimapViewChange = () => {
        if (!graph) return
        graph.disposePlugins();
        graph.use(
            new MiniMap({
                container: minimap,
                width: 300,
                height: 160,
                padding: 10,
            }),
        )
    }
    //官方文档写的是componentDidMount，因为react取消了三个生命周期函数，所以使用useEffect


    // 获取container对象
    const refContainer = (container: HTMLDivElement) => {
        setcontainer(container);
    }
    // 获取container对象
    const refMinimap = (minimap: HTMLDivElement) => {
        setminimap(minimap);
    }
    /**
     * 保存节点
     * 可新建空白便签
     * 不可新建空白注释
     * 编辑注释如果没有内容等同于删除
     */
    const saveNode = (type: any,) => {
        setMemoModal(false)
        //不可新建空白注释
        console.log(`type=${type}, isAdd$=${isAdd}, txt=${txt},state.txtStr=${state.txtStr}`)
        if (type === 'comments' && isAdd && !state.txtStr) return
        if (isAdd) {
            createNode(type)
        } else {

            let params: any = deepCopy(subjectData.current)
            params.$operate$ = 'save'
            let deleteArr: any = []
            //增量传值，所以将memos、comments、relationBelongTos置空
            params.memos = []
            params.comments = []
            params.relationBelongTos = []
            // //console.log(selectedCells.current[0].data.data)
            params[type] = [{ ...selectedCells.current[0].data.data, content: state.txtStr }]
            if (type === 'comments' && !txt) {
                params[type][0].$operate$ = 'delete'
                deleteArr.push(params[type][0].id)
            }
            selectedCells.current[0].setData({ ...selectedCells.current[0].data, label: state.txtStr })
            graph.removeCells(deleteArr)
            saveSubject(params, selectedCells.current[0],)
        }
    }
    const onPic = async (e: any): Promise<any> => {
        try {
        } catch (err) { }

    }
    return (
        <div className='' style={{ width: "100%", height: '100%', backgroundColor: '#EFF3F3' }}>
            {/* <ProgressContext.Provider value={progress}>
                <X6ReactPortalProvider />
            </ProgressContext.Provider> */}
            <Preview visible={previewVisible} content={markDown} onClose={() => { setPreviewVisible(false); setMarkDown('') }} />
            <Modal
                centered
                onCancel={() => {
                    setVisibleModal(false)
                }}
                footer={[
                    <Button className='btn ' key='btn' onClick={() => {
                        setVisibleModal(false)
                    }}>取消</Button>,
                    <Button className='btn ' key='btn1' type="primary" danger onClick={() => {

                        if (operationType === 'remove') {
                            removeNode()
                            setVisibleModal(false)
                        } else {
                            deleteNode(selectedCells.current[0].data.type)
                            setVisibleModal(false)
                        }
                    }}>{(operationType === 'remove') ? '确认移除' : '确认删除'}</Button>,


                ]}
                title={`确认${operationType === 'remove' ? '移除' : '删除'}?`}
                width={'800px'}
                open={visibleModal}>
                {/* removeNode('memos',) */}
                {operationType === 'remove' ? '确认移除便签？' :
                    <>
                        {selectedCells.current[0]?.data?.type === 'memos' ? '删除便签将同时删除全部关联关系，确认删除？' : ''}
                        {selectedCells.current[0]?.data?.type === 'comments' ? "确认删除此注释？" : ''}
                        {selectedCells.current[0]?.data?.type === 'relationBelongTos' ? '确认删除此关系？' : ''}</>}
            </Modal>
            <div id="container" ref={refContainer} className={style.container}>
            </div>
            <div className={style.minimap} id='minimap' ref={refMinimap} />
            <LableDrawer type={'memo'} className={'customDraw'} title={'任务内容'} subjectData={store.memoInfo} visible={store.showDrawLabel} onClose={() => {
                dispatch({
                    type: 'SET_SHOWDRAWLABEL',
                    data: false
                });
            }} />
            {/* <TagMetaMenu visible={store.showLable} onClose={() => {
                dispatch({
                    type: 'SET_SHOWLABLE',
                    data: false
                });
            }} ></TagMetaMenu> */}
            {/* {tagVisible && <SelectTag visible={tagVisible} isAdd={isAdd} operationType={operationType} saveNode={(e, text) => {
                setTxt(text)
                state.txtStr = text
                setState(state);
                saveNode(e)
            }} onClose={() => {
                setTagVisible(false)
            }} />} */}
            {/* <MemoModal saveNode={(e, text) => {
                setTxt(text)
                state.txtStr = text
                setState(state);
                saveNode(e)
            }} isAdd={isAdd} operationType={operationType} /> */}
            {/* <Modal
                centered
                onCancel={() => {
                    setMemoModal(false)
                }}
                footer={[
                    <Button className='btn ' key='btn1' type="primary" onClick={() => {
                        state.txtStr = txt
                        setState(state)
                        if (operationType === 'comments') {
                            saveNode('comments')
                        } else if (operationType === 'relationBelongTos') {
                            saveNode('relationBelongTos')
                        } else {
                            saveNode('memos')
                        }
                    }}>保存{operationName}</Button>,
                ]}
                title={`${isAdd ? '新建' : '编辑'}${operationName}`}
                width={'800px'}
                open={store.memoModal}>

                <TextArea rows={6} placeholder={`请输入${operationName}内容`} defaultValue={store.memoInfo?.data?.content} ref={inputRef} value={txt} onChange={(e) => {
                    setTxt(e.target.value)
                    state.txtStr = e.target.value
                    setState(state)
                }} onPressEnter={() => {
                }} />
            </Modal> */}
            {/* <TaskTagPop /> */}
            {/* <MarkDownPop /> */}


            {/* {imgPreview && <Modal
                onCancel={() => {
                    setImgPreview(false)
                }}
                title={taskInfo.name}
                width={'80%'}
                footer={null}
                open={imgPreview}>
                <div data-flex='main:justify cross.center'>
                    <div className='mb-20 clamp1 tc' >{taskInfo.title}</div>
                </div>
                {taskInfo.name === '图片格式' ?
                    <div className='pos-r' data-flex='main:center cross:center'>
                        <div className={style.img} style={{ backgroundImage: `url(${getImgUrlById(imgId)})` }}>
                            <div className={`previewImg`}>
                                <Image
                                    src={getImgUrlById(imgId)}
                                    fallback={imgId}
                                />
                            </div>
                        </div>

                    </div> :
                    <ImageOverlays type={'preview'} disable imgId={imgId} onChange={(e) => {
                        // setAnnotation(e)
                    }} />
                }
                <div className='mb-20' ></div>
            </Modal>} */}
            <Modal
                onCancel={() => {
                    setAddThemeVisible(false)
                    setSubjectTitle('')
                    setSubjeckPrivate(false)
                }}
                title={'新建主题'}

                width={'800px'}
                footer={[<><Checkbox key='btn' checked={subjeckPrivate} onChange={(e) => { setSubjeckPrivate(e.target.checked) }}>私有</Checkbox><Button className='btn ' disabled={(subjectTitle) ? false : true} key='btn' type="primary" onClick={() => {
                    saveSonSubject()
                }}>确定创建</Button></>]}
                open={addThemeVisible}>
                <div>
                    <Input placeholder="请输入主题名称" value={subjectTitle} ref={titleRef} onChange={(e) => {
                        setSubjectTitle(e.target.value)
                    }} onPressEnter={() => {
                        saveSonSubject()
                    }} />
                </div>
            </Modal>
            <Users title={'选择执行人'} visible={usersVisible} onList={userList} onRefresh={(e, row) => { form.setFieldsValue({ executorId: e }); setExecutorInfo(row); setUsersVisible(false) }} onClose={() => { setUsersVisible(false); }} />
            {/* <Chat onClose={() => {
                dispatch({
                    type: 'SET_SHOWCHAT',
                    data: false
                });
            }} /> */}
            <CreatePop visible={store.showCreateChat} onClose={() => {
                dispatch({
                    type: 'SET_SHOWCREATECHAT',
                    data: false
                });
            }} />
            {modalBoxShow && <div className={style.modalBox}></div>}
        </div >
    )
}

export default Memo

